(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js', './korge-root-korim.js', './korge-root-korge.js', './korge-root-korma.js', './korge-root-korio.js', './korge-root-klock.js', './korge-root-korgw.js', './korge-root-korau.js', './korge-root-korinject.js', './korge-root-kmem.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./korge-root-korim.js'), require('./korge-root-korge.js'), require('./korge-root-korma.js'), require('./korge-root-korio.js'), require('./korge-root-klock.js'), require('./korge-root-korgw.js'), require('./korge-root-korau.js'), require('./korge-root-korinject.js'), require('./korge-root-kmem.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'paf'.");
    }
    if (typeof this['korge-root-korim'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'korge-root-korim' was not found. Please, check whether 'korge-root-korim' is loaded prior to 'paf'.");
    }
    if (typeof this['korge-root-korge'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'korge-root-korge' was not found. Please, check whether 'korge-root-korge' is loaded prior to 'paf'.");
    }
    if (typeof this['korge-root-korma'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'korge-root-korma' was not found. Please, check whether 'korge-root-korma' is loaded prior to 'paf'.");
    }
    if (typeof this['korge-root-korio'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'korge-root-korio' was not found. Please, check whether 'korge-root-korio' is loaded prior to 'paf'.");
    }
    if (typeof this['korge-root-klock'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'korge-root-klock' was not found. Please, check whether 'korge-root-klock' is loaded prior to 'paf'.");
    }
    if (typeof this['korge-root-korgw'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'korge-root-korgw' was not found. Please, check whether 'korge-root-korgw' is loaded prior to 'paf'.");
    }
    if (typeof this['korge-root-korau'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'korge-root-korau' was not found. Please, check whether 'korge-root-korau' is loaded prior to 'paf'.");
    }
    if (typeof this['korge-root-korinject'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'korge-root-korinject' was not found. Please, check whether 'korge-root-korinject' is loaded prior to 'paf'.");
    }
    if (typeof this['korge-root-kmem'] === 'undefined') {
      throw new Error("Error loading module 'paf'. Its dependency 'korge-root-kmem' was not found. Please, check whether 'korge-root-kmem' is loaded prior to 'paf'.");
    }
    root.paf = factory(typeof paf === 'undefined' ? {} : paf, this['kotlin-kotlin-stdlib-js-ir'], this['korge-root-korim'], this['korge-root-korge'], this['korge-root-korma'], this['korge-root-korio'], this['korge-root-klock'], this['korge-root-korgw'], this['korge-root-korau'], this['korge-root-korinject'], this['korge-root-kmem']);
  }
}(this, function (_, kotlin_kotlin, kotlin_com_soywiz_korlibs_korim_korim, kotlin_com_soywiz_korlibs_korge2_korge, kotlin_com_soywiz_korlibs_korma_korma, kotlin_com_soywiz_korlibs_korio_korio, kotlin_com_soywiz_korlibs_klock_klock, kotlin_com_soywiz_korlibs_korgw_korgw, kotlin_com_soywiz_korlibs_korau_korau, kotlin_com_soywiz_korlibs_korinject_korinject, kotlin_com_soywiz_korlibs_kmem_kmem) {
  'use strict';
  //region block: imports
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.i;
  var Unit_getInstance = kotlin_kotlin.$_$.t2;
  var protoOf = kotlin_kotlin.$_$.f9;
  var VOID = kotlin_kotlin.$_$.nd;
  var classMeta = kotlin_kotlin.$_$.a8;
  var setMetadataFor = kotlin_kotlin.$_$.g9;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r1;
  var padStart = kotlin_kotlin.$_$.ab;
  var slice = kotlin_com_soywiz_korlibs_korim_korim.$_$.s1;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.id;
  var Scene = kotlin_com_soywiz_korlibs_korge2_korge.$_$.p;
  var Companion_getInstance = kotlin_com_soywiz_korlibs_korge2_korge.$_$.h;
  var get_TEXTURED_ARRAY_QUAD_INDICES = kotlin_com_soywiz_korlibs_korge2_korge.$_$.l;
  var TexturedVertexArray = kotlin_com_soywiz_korlibs_korge2_korge.$_$.m;
  var Bitmaps_getInstance = kotlin_com_soywiz_korlibs_korim_korim.$_$.y;
  var get_Bitmaps_white = kotlin_com_soywiz_korlibs_korim_korim.$_$.i1;
  var Companion_getInstance_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.e7;
  var Companion_getInstance_1 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.i;
  var _Anchor___get_sx__impl__4wuc7c = kotlin_com_soywiz_korlibs_korma_korma.$_$.y;
  var _Anchor___get_sy__impl__xqgt9j = kotlin_com_soywiz_korlibs_korma_korma.$_$.z;
  var Companion_getInstance_2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.j7;
  var Companion_getInstance_3 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.g;
  var contains = kotlin_kotlin.$_$.n3;
  var Bitmap32 = kotlin_com_soywiz_korlibs_korim_korim.$_$.f1;
  var objectMeta = kotlin_kotlin.$_$.e9;
  var CoroutineImpl = kotlin_kotlin.$_$.o7;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.x6;
  var invoke = kotlin_com_soywiz_korlibs_korio_korio.$_$.t1;
  var Companion_getInstance_4 = kotlin_kotlin.$_$.s2;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.y1;
  var intercepted = kotlin_kotlin.$_$.z6;
  var SafeContinuation_init_$Create$ = kotlin_kotlin.$_$.u;
  var _Frequency___init__impl__upasnx = kotlin_com_soywiz_korlibs_klock_klock.$_$.c;
  var addFixedUpdater = kotlin_com_soywiz_korlibs_korge2_korge.$_$.x;
  var returnIfSuspended = kotlin_kotlin.$_$.f;
  var Container = kotlin_com_soywiz_korlibs_korge2_korge.$_$.t;
  var launchAsap = kotlin_com_soywiz_korlibs_korio_korio.$_$.v1;
  var Signal = kotlin_com_soywiz_korlibs_korio_korio.$_$.r1;
  var Anchor = kotlin_com_soywiz_korlibs_korma_korma.$_$.y8;
  var launchImmediately = kotlin_com_soywiz_korlibs_korio_korio.$_$.x1;
  var dispatch$default = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.a1;
  var dispatch = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.o3;
  var onEvents = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.p3;
  var KMutableProperty0 = kotlin_kotlin.$_$.da;
  var getPropertyCallableRef = kotlin_kotlin.$_$.i8;
  var KMutableProperty1 = kotlin_kotlin.$_$.ea;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.o;
  var _PlaybackTimes___init__impl__rt6rw2 = kotlin_com_soywiz_korlibs_korau_korau.$_$.c;
  var THROW_CCE = kotlin_kotlin.$_$.pc;
  var AsyncInjector = kotlin_com_soywiz_korlibs_korinject_korinject.$_$.e;
  var FixedSizeContainer = kotlin_com_soywiz_korlibs_korge2_korge.$_$.u;
  var Stage = kotlin_com_soywiz_korlibs_korge2_korge.$_$.v;
  var getKClass = kotlin_kotlin.$_$.b;
  var get_AlphaTransition = kotlin_com_soywiz_korlibs_korge2_korge.$_$.n;
  var Companion_getInstance_5 = kotlin_com_soywiz_korlibs_korma_korma.$_$.q7;
  var withEasing = kotlin_com_soywiz_korlibs_korge2_korge.$_$.q;
  var Companion_getInstance_6 = kotlin_com_soywiz_korlibs_korma_korma.$_$.o7;
  var views = kotlin_com_soywiz_korlibs_korge2_korge.$_$.d;
  var Size__component1_impl_9kmfl4 = kotlin_com_soywiz_korlibs_korma_korma.$_$.s5;
  var Size__component2_impl_93kt6x = kotlin_com_soywiz_korlibs_korma_korma.$_$.t5;
  var findFirstAscendant = kotlin_com_soywiz_korlibs_korge2_korge.$_$.b1;
  var _Size___init__impl__aywn0g = kotlin_com_soywiz_korlibs_korma_korma.$_$.r5;
  var SceneContainer = kotlin_com_soywiz_korlibs_korge2_korge.$_$.o;
  var addTo = kotlin_com_soywiz_korlibs_korge2_korge.$_$.y;
  var Companion_getInstance_7 = kotlin_com_soywiz_korlibs_klock_klock.$_$.y;
  var _Size___init__impl__aywn0g_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.q5;
  var Colors_getInstance = kotlin_com_soywiz_korlibs_korim_korim.$_$.z;
  var Korge = kotlin_com_soywiz_korlibs_korge2_korge.$_$.e;
  var get_EmptyContinuation = kotlin_kotlin.$_$.a7;
  var get_resourcesVfs = kotlin_com_soywiz_korlibs_korio_korio.$_$.m2;
  var readAtlas = kotlin_com_soywiz_korlibs_korim_korim.$_$.a;
  var readBitmapFont = kotlin_com_soywiz_korlibs_korim_korim.$_$.b;
  var readSound = kotlin_com_soywiz_korlibs_korau_korau.$_$.b;
  var readMusic = kotlin_com_soywiz_korlibs_korau_korau.$_$.a;
  var Companion_getInstance_8 = kotlin_com_soywiz_korlibs_korim_korim.$_$.c1;
  var get_DefaultStringTextRenderer = kotlin_com_soywiz_korlibs_korim_korim.$_$.k2;
  var Companion_getInstance_9 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.j;
  var Text = kotlin_com_soywiz_korlibs_korge2_korge.$_$.w;
  var position = kotlin_com_soywiz_korlibs_korge2_korge.$_$.d1;
  var delay = kotlin_com_soywiz_korlibs_korge2_korge.$_$.a;
  var println = kotlin_kotlin.$_$.s7;
  var anchor = kotlin_com_soywiz_korlibs_korge2_korge.$_$.z;
  var scale = kotlin_com_soywiz_korlibs_korge2_korge.$_$.e1;
  var numberRangeToNumber = kotlin_kotlin.$_$.y8;
  var Default_getInstance = kotlin_kotlin.$_$.p2;
  var random = kotlin_kotlin.$_$.x9;
  var numberToInt = kotlin_kotlin.$_$.b9;
  var ensureNotNull = kotlin_kotlin.$_$.xc;
  var anchor_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.a1;
  var KeyEvent = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.t3;
  var setBits = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.e6;
  var unsetBits = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.z6;
  var get_keys = kotlin_com_soywiz_korlibs_korge2_korge.$_$.k;
  var scale_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.f1;
  var Vector2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.k9;
  var position_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.c1;
  var _interpolateFloat = kotlin_com_soywiz_korlibs_korge2_korge.$_$.s;
  var async = kotlin_com_soywiz_korlibs_korio_korio.$_$.s1;
  var readBitmap = kotlin_com_soywiz_korlibs_korim_korim.$_$.e;
  var Image_init_$Create$ = kotlin_com_soywiz_korlibs_korge2_korge.$_$.f;
  var V2 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.r;
  var tween = kotlin_com_soywiz_korlibs_korge2_korge.$_$.c;
  var delay_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Collisions, 'Collisions', classMeta);
  setMetadataFor(Collider, 'Collider', classMeta);
  setMetadataFor(SceneBase, 'SceneBase', classMeta, Scene, VOID, VOID, VOID, [1, 0]);
  setMetadataFor(ImageData, 'ImageData', classMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(Process$slambda, 'Process$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(Process$frame$slambda, 'Process$frame$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($frameCOROUTINE$0, '$frameCOROUTINE$0', classMeta, CoroutineImpl);
  setMetadataFor(Process, 'Process', classMeta, Container, VOID, VOID, VOID, [0]);
  setMetadataFor(loop$slambda, 'loop$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(GameState, 'GameState', classMeta);
  setMetadataFor(PafSounds, 'PafSounds', classMeta);
  setMetadataFor(main$slambda$slambda, 'main$slambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(main$slambda$slambda_1, 'main$slambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(main$slambda$slambda_3, 'main$slambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(main$slambda, 'main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor($mainCOROUTINE$1, '$mainCOROUTINE$1', classMeta, CoroutineImpl);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($loadAllCOROUTINE$2, '$loadAllCOROUTINE$2', classMeta, CoroutineImpl);
  setMetadataFor($loadGfxCOROUTINE$3, '$loadGfxCOROUTINE$3', classMeta, CoroutineImpl);
  setMetadataFor($loadMusicCOROUTINE$4, '$loadMusicCOROUTINE$4', classMeta, CoroutineImpl);
  setMetadataFor(Resources, 'Resources', classMeta, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(GameScene$inicio$main$slambda, 'GameScene$inicio$main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(GameScene$inicio$main$slambda_1, 'GameScene$inicio$main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($mainCOROUTINE$6, '$mainCOROUTINE$6', classMeta, CoroutineImpl);
  setMetadataFor($mainCOROUTINE$7, '$mainCOROUTINE$7', classMeta, CoroutineImpl);
  setMetadataFor($mainCOROUTINE$8, '$mainCOROUTINE$8', classMeta, CoroutineImpl);
  setMetadataFor(GameScene$prota$main$slambda, 'GameScene$prota$main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(GameScene$prota$main$slambda_1, 'GameScene$prota$main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor($mainCOROUTINE$9, '$mainCOROUTINE$9', classMeta, CoroutineImpl);
  setMetadataFor($mainCOROUTINE$10, '$mainCOROUTINE$10', classMeta, CoroutineImpl);
  setMetadataFor($mainCOROUTINE$11, '$mainCOROUTINE$11', classMeta, CoroutineImpl);
  setMetadataFor(inicio, 'inicio', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(bola, 'bola', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(explota, 'explota', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(prota, 'prota', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(disparo, 'disparo', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(controlador, 'controlador', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(GameScene$controlador_de_bolas$slambda, 'GameScene$controlador_de_bolas$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($sceneInitCOROUTINE$5, '$sceneInitCOROUTINE$5', classMeta, CoroutineImpl);
  setMetadataFor($controlador_de_bolasCOROUTINE$12, '$controlador_de_bolasCOROUTINE$12', classMeta, CoroutineImpl);
  setMetadataFor(GameScene, 'GameScene', classMeta, SceneBase, VOID, VOID, VOID, [0, 1]);
  setMetadataFor(LoadingScene$sceneAfterInit$slambda, 'LoadingScene$sceneAfterInit$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(LoadingScene$splash$slambda, 'LoadingScene$splash$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($sceneAfterInitCOROUTINE$13, '$sceneAfterInitCOROUTINE$13', classMeta, CoroutineImpl);
  setMetadataFor($splashCOROUTINE$14, '$splashCOROUTINE$14', classMeta, CoroutineImpl);
  setMetadataFor($logoCOROUTINE$15, '$logoCOROUTINE$15', classMeta, CoroutineImpl);
  setMetadataFor(LoadingScene, 'LoadingScene', classMeta, Scene, VOID, VOID, VOID, [0, 1]);
  setMetadataFor(Foto, 'Foto', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(TitleScene$inicio$main$slambda, 'TitleScene$inicio$main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(TitleScene$inicio$main$slambda_1, 'TitleScene$inicio$main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(TitleScene$inicio$main$slambda_3, 'TitleScene$inicio$main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor($mainCOROUTINE$19, '$mainCOROUTINE$19', classMeta, CoroutineImpl);
  setMetadataFor($mainCOROUTINE$20, '$mainCOROUTINE$20', classMeta, CoroutineImpl);
  setMetadataFor($mainCOROUTINE$21, '$mainCOROUTINE$21', classMeta, CoroutineImpl);
  setMetadataFor($mainCOROUTINE$22, '$mainCOROUTINE$22', classMeta, CoroutineImpl);
  setMetadataFor(inicio_0, 'inicio', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(pulsaIntro, 'pulsaIntro', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(letraTitulo, 'letraTitulo', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor(protaDemo, 'protaDemo', classMeta, Process, VOID, VOID, VOID, [0]);
  setMetadataFor($sceneInitCOROUTINE$16, '$sceneInitCOROUTINE$16', classMeta, CoroutineImpl);
  setMetadataFor($sceneDestroyCOROUTINE$17, '$sceneDestroyCOROUTINE$17', classMeta, CoroutineImpl);
  setMetadataFor($sceneAfterDestroyCOROUTINE$18, '$sceneAfterDestroyCOROUTINE$18', classMeta, CoroutineImpl);
  setMetadataFor(TitleScene, 'TitleScene', classMeta, SceneBase, VOID, VOID, VOID, [0, 1]);
  //endregion
  function checkCollision($this, view, radius, offsetY, it) {
    if (view.b6d() - radius > it.b6d())
      return false;
    if (view.b6d() + radius < it.b6d())
      return false;
    if (view.c6d() - radius > it.c6d() + offsetY)
      return false;
    if (view.c6d() + radius < it.c6d() + offsetY)
      return false;
    return true;
  }
  function Collisions() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    tmp.rcd_1 = tmp$ret$0;
  }
  protoOf(Collisions).dt = function () {
    this.rcd_1.v2();
  };
  protoOf(Collisions).scd = function (arrow) {
    this.rcd_1.b(arrow);
  };
  protoOf(Collisions).tcd = function (arrow) {
    this.rcd_1.t2(arrow);
  };
  protoOf(Collisions).ucd = function (view, radius, offsetY) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_firstOrNull = this.rcd_1;
      var tmp0_iterator = tmp0_firstOrNull.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'gameplay.Collisions.colidesWith.<anonymous>' call
        tmp$ret$0 = checkCollision(this, view, radius, offsetY, element);
        if (tmp$ret$0) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(Collisions).vcd = function (view, radius, offsetY, $super) {
    radius = radius === VOID ? 20 : radius;
    offsetY = offsetY === VOID ? 0 : offsetY;
    return $super === VOID ? this.ucd(view, radius, offsetY) : $super.ucd.call(this, view, radius, offsetY);
  };
  function Collider(collisions, container) {
    this.wcd_1 = collisions;
    this.xcd_1 = container;
    this.ycd_1 = true;
    this.wcd_1.scd(this.xcd_1);
  }
  protoOf(Collider).zcd = function () {
    this.ycd_1 = false;
    this.xcd_1.xb0();
    this.wcd_1.tcd(this.xcd_1);
  };
  function get_imageCache() {
    _init_properties_Engine_kt__fnrbfm();
    return imageCache;
  }
  var imageCache;
  function getImage(graph) {
    _init_properties_Engine_kt__fnrbfm();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.getOrPut' call
    var tmp0_getOrPut = get_imageCache();
    var value = tmp0_getOrPut.z1(graph);
    var tmp;
    if (value == null) {
      return graph === 0 ? slice(Companion_getInstance_10().kce_1) : Companion_getInstance_11().jce().ro(padStart(graph.toString(), 3, _Char___init__impl__6a9atx(48)) + '.png');
    } else {
      tmp = value;
    }
    tmp$ret$0 = tmp;
    return tmp$ret$0;
  }
  function set_currentScene(_set____db54di) {
    _init_properties_Engine_kt__fnrbfm();
    currentScene = _set____db54di;
  }
  function get_currentScene() {
    _init_properties_Engine_kt__fnrbfm();
    var tmp = currentScene;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('currentScene');
    }
  }
  var currentScene;
  function SceneBase() {
    Scene.call(this);
    set_currentScene(this);
  }
  function ImageData() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    var tmp0__get_QUAD_INDICES__35d4te = Companion_getInstance();
    tmp$ret$0 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp.lce_1 = new TexturedVertexArray(4, tmp$ret$0);
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    var tmp0__get_white__j8g7zy = Bitmaps_getInstance();
    tmp$ret$1 = get_Bitmaps_white();
    tmp_0.mce_1 = tmp$ret$1;
    this.nce_1 = Companion_getInstance_0().i3a_1;
    this.oce_1 = true;
    this.pce_1 = Companion_getInstance_1().wa1_1;
  }
  protoOf(ImageData).nbg = function () {
    return -this.zay();
  };
  protoOf(ImageData).obg = function () {
    return -this.aaz();
  };
  protoOf(ImageData).dbe = function () {
    return this.mce_1.ck();
  };
  protoOf(ImageData).ebe = function () {
    return this.mce_1.dk();
  };
  protoOf(ImageData).b3t = function () {
    return this.mce_1.b3t();
  };
  protoOf(ImageData).c3t = function () {
    return this.mce_1.c3t();
  };
  protoOf(ImageData).o3s = function () {
    return this.mce_1.o3s();
  };
  protoOf(ImageData).p3s = function () {
    return this.mce_1.p3s();
  };
  protoOf(ImageData).qbg = function () {
    return _Anchor___get_sx__impl__4wuc7c(this.nce_1) * this.o3s();
  };
  protoOf(ImageData).rbg = function () {
    return _Anchor___get_sy__impl__xqgt9j(this.nce_1) * this.p3s();
  };
  protoOf(ImageData).zay = function () {
    return this.qbg() - this.b3t();
  };
  protoOf(ImageData).aaz = function () {
    return this.rbg() - this.c3t();
  };
  protoOf(ImageData).tbg = function (ctx) {
    var tmp$ret$2;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var tmp$ret$1;
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var tmp1_use = ctx.u9y_1;
    var tmp0_useBatcher = tmp1_use.qa2_1;
    if (!(tmp0_useBatcher.y9y_1 === tmp1_use)) {
      tmp0_useBatcher.y9y_1 = tmp1_use;
      tmp0_useBatcher.va3();
    }
    var tmp1_drawVertices = this.lce_1;
    var tmp2_drawVertices = ctx.cad(this.mce_1).l3s();
    var tmp3_drawVertices = this.oce_1;
    var tmp4_drawVertices = this.pce_1;
    var tmp5_drawVertices = tmp1_drawVertices.oaa_1;
    var tmp6_drawVertices = tmp1_drawVertices.paa_1;
    var tmp7_drawVertices = Companion_getInstance_2().w3f_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tmp0_setStateFast = tmp2_drawVertices.ea8_1;
      tmp1_use.haa(tmp6_drawVertices, tmp5_drawVertices);
      var tmp0_elvis_lhs = null;
      var pprogram = tmp0_elvis_lhs == null ? Companion_getInstance_3().m9j_1 : tmp0_elvis_lhs;
      if (tmp1_use.waa(tmp0_setStateFast, tmp3_drawVertices, tmp4_drawVertices, pprogram)) {
        tmp$ret$0 = Unit_getInstance();
        break $l$block;
      }
      tmp1_use.za9();
      if (!contains(tmp1_use.ga3_1, tmp0_setStateFast)) {
        tmp1_use.fa3_1 = 0;
        tmp1_use.ga3_1[0] = tmp0_setStateFast;
      }
      tmp1_use.ha3_1 = tmp3_drawVertices;
      tmp1_use.ia3_1 = tmp4_drawVertices;
      tmp1_use.ja3_1 = pprogram;
    }
    tmp1_use.taa(tmp1_drawVertices, tmp7_drawVertices, tmp5_drawVertices, tmp6_drawVertices);
    tmp$ret$1 = Unit_getInstance();
    tmp$ret$2 = tmp$ret$1;
  };
  protoOf(ImageData).qce = function (globalMatrix, renderColorMul) {
    this.lce_1.caf(0, this.nbg(), this.obg(), this.dbe(), this.ebe(), globalMatrix, this.mce_1, renderColorMul);
  };
  function Companion() {
    Companion_instance = this;
    this.kce_1 = new Bitmap32(1, 1);
  }
  var Companion_instance;
  function Companion_getInstance_10() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Process$slambda(this$0, resultContinuation) {
    this.zce_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Process$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Process$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(Process$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.zce_1.qch(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(Process$slambda).n1f = function (completion) {
    var i = new Process$slambda(this.zce_1, completion);
    return i;
  };
  function Process$slambda_0(this$0, resultContinuation) {
    var i = new Process$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function Process$frame$lambda(this$0) {
    return function ($this$addFixedUpdater) {
      invoke(this$0.och_1);
      return Unit_getInstance();
    };
  }
  function Process$frame$slambda(this$0, $safe, resultContinuation) {
    this.zch_1 = this$0;
    this.aci_1 = $safe;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Process$frame$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Process$frame$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(Process$frame$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.zch_1.och_1.s1g(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_success = Companion_getInstance_4();
            this.aci_1.h4(_Result___init__impl__xyqfz8(Unit_getInstance()));
            ;
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(Process$frame$slambda).n1f = function (completion) {
    var i = new Process$frame$slambda(this.zch_1, this.aci_1, completion);
    return i;
  };
  function Process$frame$slambda_0(this$0, $safe, resultContinuation) {
    var i = new Process$frame$slambda(this$0, $safe, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $frameCOROUTINE$0(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jci_1 = _this__u8e3s4;
    this.kci_1 = _this__u8e3s4_0;
  }
  protoOf($frameCOROUTINE$0).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            var tmp0__anonymous__q1qw7t = this;
            var safe = SafeContinuation_init_$Create$(intercepted(tmp0__anonymous__q1qw7t));
            if (!this.jci_1.pch_1) {
              this.jci_1.pch_1 = true;
              var tmp_0 = _Frequency___init__impl__upasnx(24.0);
              addFixedUpdater(this.kci_1, tmp_0, VOID, VOID, Process$frame$lambda(this.jci_1));
            }

            this.jci_1.lci(Process$frame$slambda_0(this.jci_1, safe, null));
            ;
            suspendResult = returnIfSuspended(safe.kd(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function Process(parent) {
    Companion_getInstance_10();
    Container.call(this);
    this.jch_1 = new ImageData();
    this.kch_1 = anchor$factory(this.jch_1);
    this.lch_1 = baseBitmap$factory(this.jch_1);
    this.mch_1 = smoothing$factory(this.jch_1);
    this.nch_1 = 0;
    parent.ray(this);
    var tmp = get_currentScene();
    launchAsap(tmp, Process$slambda_0(this, null));
    this.och_1 = new Signal();
    this.pch_1 = false;
  }
  protoOf(Process).ib8 = function (_set____db54di) {
    var tmp0_setValue = anchor$factory_0();
    return this.kch_1.set(new Anchor(_set____db54di));
  };
  protoOf(Process).mbg = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = anchor$factory_1();
    tmp$ret$0 = this.kch_1.get().s3a_1;
    return tmp$ret$0;
  };
  protoOf(Process).cbe = function (_set____db54di) {
    var tmp0_setValue = bitmap$factory();
    return this.lch_1.set(_set____db54di);
  };
  protoOf(Process).t5n = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = bitmap$factory_0();
    tmp$ret$0 = this.lch_1.get();
    return tmp$ret$0;
  };
  protoOf(Process).zbx = function (_set____db54di) {
    var tmp0_setValue = smoothing$factory_0();
    return this.mch_1.set(_set____db54di);
  };
  protoOf(Process).mci = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = smoothing$factory_1();
    tmp$ret$0 = this.mch_1.get();
    return tmp$ret$0;
  };
  protoOf(Process).nci = function (value) {
    this.nch_1 = value;
    this.cbe(getImage(value));
  };
  protoOf(Process).oci = function () {
    return this.nch_1;
  };
  protoOf(Process).qav = function (ctx) {
    this.jch_1.qce(this.kb0(), this.ob0());
    this.jch_1.tbg(ctx);
    protoOf(Container).qav.call(this, ctx);
  };
  protoOf(Process).qch = function ($completion) {
    return Unit_getInstance();
  };
  protoOf(Process).pci = function (_this__u8e3s4, $completion) {
    var tmp = new $frameCOROUTINE$0(this, _this__u8e3s4, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Process).lci = function (callback) {
    return launchImmediately(get_currentScene(), callback);
  };
  protoOf(Process).qci = function (callback) {
    return launchAsap(get_currentScene(), callback);
  };
  function loop(_this__u8e3s4, block) {
    _init_properties_Engine_kt__fnrbfm();
    launchImmediately(_this__u8e3s4, loop$slambda_0(block, null));
  }
  function loop$slambda($block, resultContinuation) {
    this.zci_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loop$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(loop$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(loop$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 4;
              continue $sm;
            }

            this.hh_1 = 2;
            suspendResult = this.zci_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 1;
            continue $sm;
          case 3:
            throw this.kh_1;
          case 4:
            return Unit_getInstance();
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(loop$slambda).n1f = function (completion) {
    var i = new loop$slambda(this.zci_1, completion);
    return i;
  };
  function loop$slambda_0($block, resultContinuation) {
    var i = new loop$slambda($block, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function anchor$factory($b0) {
    return getPropertyCallableRef('anchor', 0, KMutableProperty0, function () {
      return new Anchor($b0.nce_1);
    }, function (value) {
      $b0.nce_1 = value.s3a_1;
      return Unit_getInstance();
    });
  }
  function baseBitmap$factory($b0) {
    return getPropertyCallableRef('baseBitmap', 0, KMutableProperty0, function () {
      return $b0.mce_1;
    }, function (value) {
      $b0.mce_1 = value;
      return Unit_getInstance();
    });
  }
  function smoothing$factory($b0) {
    return getPropertyCallableRef('smoothing', 0, KMutableProperty0, function () {
      return $b0.oce_1;
    }, function (value) {
      $b0.oce_1 = value;
      return Unit_getInstance();
    });
  }
  function anchor$factory_0() {
    return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
      return new Anchor(receiver.mbg());
    }, function (receiver, value) {
      return receiver.ib8(value.s3a_1);
    });
  }
  function anchor$factory_1() {
    return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
      return new Anchor(receiver.mbg());
    }, function (receiver, value) {
      return receiver.ib8(value.s3a_1);
    });
  }
  function bitmap$factory() {
    return getPropertyCallableRef('bitmap', 1, KMutableProperty1, function (receiver) {
      return receiver.t5n();
    }, function (receiver, value) {
      return receiver.cbe(value);
    });
  }
  function bitmap$factory_0() {
    return getPropertyCallableRef('bitmap', 1, KMutableProperty1, function (receiver) {
      return receiver.t5n();
    }, function (receiver, value) {
      return receiver.cbe(value);
    });
  }
  function smoothing$factory_0() {
    return getPropertyCallableRef('smoothing', 1, KMutableProperty1, function (receiver) {
      return receiver.mci();
    }, function (receiver, value) {
      return receiver.zbx(value);
    });
  }
  function smoothing$factory_1() {
    return getPropertyCallableRef('smoothing', 1, KMutableProperty1, function (receiver) {
      return receiver.mci();
    }, function (receiver, value) {
      return receiver.zbx(value);
    });
  }
  var properties_initialized_Engine_kt_oy53wk;
  function _init_properties_Engine_kt__fnrbfm() {
    if (properties_initialized_Engine_kt_oy53wk) {
    } else {
      properties_initialized_Engine_kt_oy53wk = true;
      var tmp$ret$0;
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp$ret$0 = LinkedHashMap_init_$Create$();
      imageCache = tmp$ret$0;
    }
  }
  function set_currentGameState(_set____db54di) {
    _init_properties_GameState_kt__8kf0b1();
    currentGameState = _set____db54di;
  }
  function get_currentGameState() {
    _init_properties_GameState_kt__8kf0b1();
    return currentGameState;
  }
  var currentGameState;
  function set_record(_set____db54di) {
    _init_properties_GameState_kt__8kf0b1();
    record = _set____db54di;
  }
  function get_record() {
    _init_properties_GameState_kt__8kf0b1();
    return record;
  }
  var record;
  function GameState() {
    this.acj_1 = false;
    this.bcj_1 = false;
    this.ccj_1 = false;
    this.dcj_1 = 0;
    this.ecj_1 = 4;
    this.fcj_1 = 0;
    this.gcj_1 = 0;
    this.hcj_1 = new Collisions();
    this.icj_1 = new Collisions();
  }
  protoOf(GameState).jcj = function () {
    this.hcj_1.dt();
    this.icj_1.dt();
  };
  var properties_initialized_GameState_kt_d2ckpb;
  function _init_properties_GameState_kt__8kf0b1() {
    if (properties_initialized_GameState_kt_d2ckpb) {
    } else {
      properties_initialized_GameState_kt_d2ckpb = true;
      currentGameState = new GameState();
      record = 0;
    }
  }
  function PafSounds(sfxDisparo, sfxBota, sfxPaf, music) {
    this.kcj_1 = sfxDisparo;
    this.lcj_1 = sfxBota;
    this.mcj_1 = sfxPaf;
    this.ncj_1 = music;
    this.ocj_1 = false;
  }
  protoOf(PafSounds).pcj = function () {
    if (this.ocj_1)
      return Unit_getInstance();
    var tmp$ret$0;
    // Inline function 'korlibs.audio.sound.playbackTimes' call
    tmp$ret$0 = _PlaybackTimes___init__impl__rt6rw2(1);
    this.lcj_1.f92(tmp$ret$0);
  };
  protoOf(PafSounds).qcj = function () {
    if (this.ocj_1)
      return Unit_getInstance();
    var tmp$ret$0;
    // Inline function 'korlibs.audio.sound.playbackTimes' call
    tmp$ret$0 = _PlaybackTimes___init__impl__rt6rw2(1);
    this.kcj_1.f92(tmp$ret$0);
  };
  protoOf(PafSounds).rcj = function () {
    if (this.ocj_1)
      return Unit_getInstance();
    var tmp$ret$0;
    // Inline function 'korlibs.audio.sound.playbackTimes' call
    tmp$ret$0 = _PlaybackTimes___init__impl__rt6rw2(1);
    this.mcj_1.f92(tmp$ret$0);
  };
  protoOf(PafSounds).scj = function () {
    if (this.ocj_1)
      return Unit_getInstance();
    this.ncj_1.h92();
  };
  var BUTTON_UP;
  var BUTTON_DOWN;
  function get_BUTTON_LEFT() {
    return BUTTON_LEFT;
  }
  var BUTTON_LEFT;
  function get_BUTTON_RIGHT() {
    return BUTTON_RIGHT;
  }
  var BUTTON_RIGHT;
  function get_BUTTON_A() {
    return BUTTON_A;
  }
  var BUTTON_A;
  function get_BUTTON_B() {
    return BUTTON_B;
  }
  var BUTTON_B;
  function get_BUTTON_C() {
    return BUTTON_C;
  }
  var BUTTON_C;
  function get_BUTTON_START() {
    return BUTTON_START;
  }
  var BUTTON_START;
  function getButtonPressed(it) {
    var tmp0_subject = it.k6b_1;
    var tmp0 = tmp0_subject.j5_1;
    switch (tmp0) {
      case 23:
      case 63:
        return BUTTON_LEFT;
      case 26:
      case 62:
        return BUTTON_RIGHT;
      case 45:
      case 65:
        return BUTTON_UP;
      case 41:
      case 64:
        return BUTTON_DOWN;
      case 0:
        return BUTTON_A;
      case 36:
        return BUTTON_A;
      case 35:
        return BUTTON_A;
      case 48:
        return BUTTON_A;
      case 46:
        return BUTTON_A;
      case 57:
        return BUTTON_START;
      default:
        return 0;
    }
  }
  function main($completion) {
    var tmp = new $mainCOROUTINE$1($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  }
  function main$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(main$slambda$slambda).nck = function ($this$mapPrototype, $completion) {
    var tmp = this.y9w($this$mapPrototype, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(main$slambda$slambda).mi = function (p1, $completion) {
    return this.nck(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $completion);
  };
  protoOf(main$slambda$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          return new LoadingScene();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(main$slambda$slambda).y9w = function ($this$mapPrototype, completion) {
    var i = new main$slambda$slambda(completion);
    i.mck_1 = $this$mapPrototype;
    return i;
  };
  function main$slambda$slambda_0(resultContinuation) {
    var i = new main$slambda$slambda(resultContinuation);
    var l = function ($this$mapPrototype, $completion) {
      return i.nck($this$mapPrototype, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function main$slambda$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(main$slambda$slambda_1).xck = function ($this$mapPrototype, $completion) {
    var tmp = this.y9w($this$mapPrototype, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(main$slambda$slambda_1).mi = function (p1, $completion) {
    return this.xck(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $completion);
  };
  protoOf(main$slambda$slambda_1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          return new TitleScene();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(main$slambda$slambda_1).y9w = function ($this$mapPrototype, completion) {
    var i = new main$slambda$slambda_1(completion);
    i.wck_1 = $this$mapPrototype;
    return i;
  };
  function main$slambda$slambda_2(resultContinuation) {
    var i = new main$slambda$slambda_1(resultContinuation);
    var l = function ($this$mapPrototype, $completion) {
      return i.xck($this$mapPrototype, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function main$slambda$slambda_3(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(main$slambda$slambda_3).hcl = function ($this$mapPrototype, $completion) {
    var tmp = this.y9w($this$mapPrototype, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(main$slambda$slambda_3).mi = function (p1, $completion) {
    return this.hcl(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $completion);
  };
  protoOf(main$slambda$slambda_3).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          return new GameScene();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(main$slambda$slambda_3).y9w = function ($this$mapPrototype, completion) {
    var i = new main$slambda$slambda_3(completion);
    i.gcl_1 = $this$mapPrototype;
    return i;
  };
  function main$slambda$slambda_4(resultContinuation) {
    var i = new main$slambda$slambda_3(resultContinuation);
    var l = function ($this$mapPrototype, $completion) {
      return i.hcl($this$mapPrototype, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function main$slambda$lambda(it) {
    return it instanceof FixedSizeContainer;
  }
  function main$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(main$slambda).b9j = function ($this$Korge, $completion) {
    var tmp = this.c9j($this$Korge, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(main$slambda).mi = function (p1, $completion) {
    return this.b9j(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(main$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            var tmp0_mapPrototype = this.qcl_1.mag();
            var tmp1_mapPrototype = main$slambda$slambda_0(null);
            var tmp2_mapPrototype = tmp0_mapPrototype.n9g(getKClass(LoadingScene), tmp1_mapPrototype);
            var tmp3_mapPrototype = main$slambda$slambda_2(null);
            var tmp4_mapPrototype = tmp2_mapPrototype.n9g(getKClass(TitleScene), tmp3_mapPrototype);
            var tmp5_mapPrototype = main$slambda$slambda_4(null);
            tmp4_mapPrototype.n9g(getKClass(GameScene), tmp5_mapPrototype);
            ;
            var tmp_0 = this;
            tmp_0.rcl_1 = withEasing(get_AlphaTransition(), Companion_getInstance_5().s3z());
            var tmp_1 = this;
            tmp_1.scl_1 = Companion_getInstance_6().k3j_1;
            this.hh_1 = 1;
            suspendResult = views(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.tcl_1 = suspendResult;
            this.ucl_1 = this.scl_1;
            this.vcl_1 = Size__component1_impl_9kmfl4(this.ucl_1);
            this.wcl_1 = Size__component2_impl_93kt6x(this.ucl_1);
            this.xcl_1 = this.vcl_1;
            this.ycl_1 = this.wcl_1;
            if (this.vcl_1 === 0.0 ? this.wcl_1 === 0.0 : false) {
              var tmp_2 = findFirstAscendant(this.qcl_1, main$slambda$lambda);
              var base = (tmp_2 == null ? true : tmp_2 instanceof FixedSizeContainer) ? tmp_2 : null;
              var tmp_3 = this;
              var tmp1_safe_receiver = base;
              var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ck();
              tmp_3.xcl_1 = tmp2_elvis_lhs == null ? this.tcl_1.s9n_1.ck() : tmp2_elvis_lhs;
              var tmp_4 = this;
              var tmp3_safe_receiver = base;
              var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.dk();
              tmp_4.ycl_1 = tmp4_elvis_lhs == null ? this.tcl_1.s9n_1.dk() : tmp4_elvis_lhs;
            }

            var tmp_5 = this;
            var tmp7_addTo = new SceneContainer(this.tcl_1, this.rcl_1, 'sceneContainer', _Size___init__impl__aywn0g(this.xcl_1, this.ycl_1));
            var tmp6_apply = addTo(tmp7_addTo, this.qcl_1);
            ;
            tmp_5.zcl_1 = tmp6_apply;
            var tmp_6 = this;
            tmp_6.acm_1 = Companion_getInstance_7().ej(0.0);
            var tmp_7 = this;
            tmp_7.bcm_1 = this.zcl_1.j9t_1;
            this.hh_1 = 2;
            suspendResult = this.zcl_1.ras(getKClass(LoadingScene), [].slice(), this.acm_1, this.bcm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            ;
            return Unit_getInstance();
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(main$slambda).c9j = function ($this$Korge, completion) {
    var i = new main$slambda(completion);
    i.qcl_1 = $this$Korge;
    return i;
  };
  function main$slambda_0(resultContinuation) {
    var i = new main$slambda(resultContinuation);
    var l = function ($this$Korge, $completion) {
      return i.b9j($this$Korge, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $mainCOROUTINE$1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($mainCOROUTINE$1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.bck_1 = _Size___init__impl__aywn0g_0(800, 600);
            this.cck_1 = _Size___init__impl__aywn0g_0(320, 240);
            this.dck_1 = Colors_getInstance().o4n('#2b2b2b');
            this.hh_1 = 1;
            suspendResult = Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.bck_1, VOID, VOID, this.cck_1, VOID, VOID, VOID, VOID, 'Paf!', VOID, this.dck_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 60.0, main$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function Companion_0() {
    Companion_instance_0 = this;
    this.gce_1 = false;
    this.hce_1 = false;
    this.ice_1 = false;
  }
  protoOf(Companion_0).jce = function () {
    var tmp = this.ace_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('pafAtlas');
    }
  };
  protoOf(Companion_0).i51 = function () {
    var tmp = this.bce_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  };
  protoOf(Companion_0).ccm = function () {
    var tmp = this.cce_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('disparoSound');
    }
  };
  protoOf(Companion_0).dcm = function () {
    var tmp = this.dce_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('botaSound');
    }
  };
  protoOf(Companion_0).ecm = function () {
    var tmp = this.ece_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('pafSound');
    }
  };
  protoOf(Companion_0).fcm = function () {
    var tmp = this.fce_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('music');
    }
  };
  var Companion_instance_0;
  function Companion_getInstance_11() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function $loadAllCOROUTINE$2(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ocm_1 = _this__u8e3s4;
  }
  protoOf($loadAllCOROUTINE$2).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 3;
            if (Companion_getInstance_11().gce_1)
              return Unit_getInstance();
            Companion_getInstance_11().gce_1 = true;
            this.hh_1 = 1;
            suspendResult = this.ocm_1.qcm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hh_1 = 2;
            suspendResult = this.ocm_1.rcm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 3) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $loadGfxCOROUTINE$3(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.acn_1 = _this__u8e3s4;
  }
  protoOf($loadGfxCOROUTINE$3).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 7;
            if (Companion_getInstance_11().hce_1)
              return Unit_getInstance();
            Companion_getInstance_11().hce_1 = true;
            this.bcn_1 = Companion_getInstance_11();
            this.hh_1 = 1;
            suspendResult = readAtlas(get_resourcesVfs().ro('fpg.atlas.json'), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ccn_1 = suspendResult;
            this.bcn_1.ace_1 = this.ccn_1;
            this.dcn_1 = Companion_getInstance_11();
            this.hh_1 = 2;
            suspendResult = readBitmapFont(get_resourcesVfs().ro('texts/I-pixel-u.fnt'), VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.ecn_1 = suspendResult;
            this.dcn_1.bce_1 = this.ecn_1;
            this.fcn_1 = Companion_getInstance_11();
            this.hh_1 = 3;
            suspendResult = readSound(get_resourcesVfs().ro('bota.wav'), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.gcn_1 = suspendResult;
            this.fcn_1.dce_1 = this.gcn_1;
            this.hcn_1 = Companion_getInstance_11();
            this.hh_1 = 4;
            suspendResult = readSound(get_resourcesVfs().ro('disparo.wav'), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.icn_1 = suspendResult;
            this.hcn_1.cce_1 = this.icn_1;
            this.jcn_1 = Companion_getInstance_11();
            this.hh_1 = 5;
            suspendResult = readSound(get_resourcesVfs().ro('paf.wav'), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.kcn_1 = suspendResult;
            this.jcn_1.ece_1 = this.kcn_1;
            this.lcn_1 = Companion_getInstance_11();
            this.hh_1 = 6;
            suspendResult = readSound(get_resourcesVfs().ro('paf.wav'), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            this.lcn_1.ece_1 = ARGUMENT;
            return Unit_getInstance();
          case 7:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 7) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $loadMusicCOROUTINE$4(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ucn_1 = _this__u8e3s4;
  }
  protoOf($loadMusicCOROUTINE$4).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            if (Companion_getInstance_11().ice_1)
              return Unit_getInstance();
            Companion_getInstance_11().ice_1 = true;
            this.vcn_1 = Companion_getInstance_11();
            this.hh_1 = 1;
            suspendResult = readMusic(get_resourcesVfs().ro('music.mp3'), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.vcn_1.fce_1 = ARGUMENT;
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function Resources(views) {
    Companion_getInstance_11();
    this.pcm_1 = views;
  }
  protoOf(Resources).wcn = function ($completion) {
    var tmp = new $loadAllCOROUTINE$2(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Resources).qcm = function ($completion) {
    var tmp = new $loadGfxCOROUTINE$3(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Resources).rcm = function ($completion) {
    var tmp = new $loadMusicCOROUTINE$4(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(Resources).xcn = function () {
    Companion_getInstance_11().gce_1 = true;
  };
  function GameScene$inicio$main$slambda(this$0, this$1, resultContinuation) {
    this.gco_1 = this$0;
    this.hco_1 = this$1;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(GameScene$inicio$main$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(GameScene$inicio$main$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(GameScene$inicio$main$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.gco_1.uco_1 = -1;
            var tmp_0 = this;
            var tmp2_text = Companion_getInstance_11().i51();
            var tmp3_text = Colors_getInstance().j48_1;
            var tmp4_text = Companion_getInstance_8().z4w_1;
            var tmp5_text = get_DefaultStringTextRenderer();
            var tmp6_text = Companion_getInstance_9().pc1_1;
            var tmp1_addTo = new Text('Felicidades', 24.0, tmp3_text, tmp2_text, tmp4_text, tmp5_text, tmp6_text, null, null);
            var tmp0_apply = addTo(tmp1_addTo, this.hco_1);
            ;
            tmp_0.ico_1 = position(tmp0_apply, 64, 100);
            this.hh_1 = 1;
            suspendResult = delay(this.gco_1, Companion_getInstance_7().ej(1.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ico_1.xb0();
            var tmp_1 = this;
            var tmp9_text = Companion_getInstance_11().i51();
            var tmp10_text = Colors_getInstance().j48_1;
            var tmp11_text = Companion_getInstance_8().z4w_1;
            var tmp12_text = get_DefaultStringTextRenderer();
            var tmp13_text = Companion_getInstance_9().pc1_1;
            var tmp8_addTo = new Text('Escenario Record', 24.0, tmp10_text, tmp9_text, tmp11_text, tmp12_text, tmp13_text, null, null);
            var tmp7_apply = addTo(tmp8_addTo, this.hco_1);
            ;
            tmp_1.jco_1 = position(tmp7_apply, 32, 100);
            this.hh_1 = 2;
            suspendResult = delay(this.gco_1, Companion_getInstance_7().ej(2.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.jco_1.xb0();
            this.hh_1 = 3;
            suspendResult = this.gco_1.yco(this.hco_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(GameScene$inicio$main$slambda).n1f = function (completion) {
    var i = new GameScene$inicio$main$slambda(this.gco_1, this.hco_1, completion);
    return i;
  };
  function GameScene$inicio$main$slambda_0(this$0, this$1, resultContinuation) {
    var i = new GameScene$inicio$main$slambda(this$0, this$1, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function GameScene$inicio$main$slambda_1($tmp14_with, this$0, this$1, resultContinuation) {
    this.hcp_1 = $tmp14_with;
    this.icp_1 = this$0;
    this.jcp_1 = this$1;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(GameScene$inicio$main$slambda_1).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(GameScene$inicio$main$slambda_1).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(GameScene$inicio$main$slambda_1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            get_currentGameState().bcj_1 = true;
            var tmp_0 = this;
            var tmp2_text = 'Escenario ' + (this.hcp_1.dcj_1 + 1 | 0);
            var tmp3_text = Companion_getInstance_11().i51();
            var tmp4_text = Colors_getInstance().j48_1;
            var tmp5_text = Companion_getInstance_8().z4w_1;
            var tmp6_text = get_DefaultStringTextRenderer();
            var tmp7_text = Companion_getInstance_9().pc1_1;
            var tmp1_addTo = new Text(tmp2_text, 24.0, tmp4_text, tmp3_text, tmp5_text, tmp6_text, tmp7_text, null, null);
            var tmp0_apply = addTo(tmp1_addTo, this.icp_1);
            ;
            tmp_0.kcp_1 = position(tmp0_apply, 64, 100);
            this.hh_1 = 1;
            suspendResult = delay(this.jcp_1, Companion_getInstance_7().ej(2.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            get_currentGameState().bcj_1 = false;
            this.kcp_1.xb0();
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(GameScene$inicio$main$slambda_1).n1f = function (completion) {
    var i = new GameScene$inicio$main$slambda_1(this.hcp_1, this.icp_1, this.jcp_1, completion);
    return i;
  };
  function GameScene$inicio$main$slambda_2($tmp14_with, this$0, this$1, resultContinuation) {
    var i = new GameScene$inicio$main$slambda_1($tmp14_with, this$0, this$1, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $mainCOROUTINE$6(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tcp_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$6).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 7;
            foto(this.tcp_1, 31, 160, 120, 100, 100, 0);
            ;
            foto(this.tcp_1, 9, 120, 224, 100, 80, 0);
            ;
            foto(this.tcp_1, 19, 284, 84, 100, 10, 0);
            ;
            new controlador(this.tcp_1.ocs_1, this.tcp_1);
            ;
            foto(this.tcp_1, 8, 282, 120, 100, 0, 0);
            ;
            var tmp_0 = this.tcp_1.ocs_1;
            var tmp2_text = Companion_getInstance_11().i51();
            var tmp3_text = Colors_getInstance().j48_1;
            var tmp4_text = Companion_getInstance_8().z4w_1;
            var tmp5_text = get_DefaultStringTextRenderer();
            var tmp6_text = Companion_getInstance_9().pc1_1;
            var tmp1_addTo = new Text('000000', 10.0, tmp3_text, tmp2_text, tmp4_text, tmp5_text, tmp6_text, null, null);
            var tmp0_apply = addTo(tmp1_addTo, this.tcp_1);
            ;
            tmp_0.vco_1 = position(tmp0_apply, 260, 112);
            var tmp_1 = this.tcp_1.ocs_1;
            var tmp9_text = Companion_getInstance_11().i51();
            var tmp10_text = Colors_getInstance().j48_1;
            var tmp11_text = Companion_getInstance_8().z4w_1;
            var tmp12_text = get_DefaultStringTextRenderer();
            var tmp13_text = Companion_getInstance_9().pc1_1;
            var tmp8_addTo = new Text('000000', 10.0, tmp10_text, tmp9_text, tmp11_text, tmp12_text, tmp13_text, null, null);
            var tmp7_apply = addTo(tmp8_addTo, this.tcp_1);
            ;
            tmp_1.wco_1 = position(tmp7_apply, 260, 149);
            this.tcp_1.ocs_1.pcs();
            this.tcp_1.ocs_1.qcs();
            new prota(this.tcp_1.ocs_1, 120);
            ;
            var tmp_2 = this;
            tmp_2.ucp_1 = get_currentGameState();
            var tmp0_subject = this.ucp_1.dcj_1;
            switch (tmp0_subject) {
              case 0:
                this.tcp_1.ocs_1.uco_1 = 14;
                new bola(this.tcp_1.ocs_1, 12, 100, 100, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 12, 140, 100, 100, 0, 2, 1);
                ;
                break;
              case 1:
                this.tcp_1.ocs_1.uco_1 = 14;
                new bola(this.tcp_1.ocs_1, 10, 100, 100, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 10, 140, 100, 100, 0, 2, 1);
                ;
                break;
              case 2:
                this.tcp_1.ocs_1.uco_1 = 14;
                new bola(this.tcp_1.ocs_1, 14, 100, 100, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 14, 140, 100, 100, 0, 2, 1);
                ;
                break;
              case 3:
                this.tcp_1.ocs_1.uco_1 = 20;
                new bola(this.tcp_1.ocs_1, 12, 70, 100, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 14, 105, 80, 50, 0, 2, 1);
                ;
                new bola(this.tcp_1.ocs_1, 14, 135, 80, 50, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 12, 170, 100, 100, 0, 2, 1);
                ;
                break;
              case 4:
                this.tcp_1.ocs_1.uco_1 = 28;
                new bola(this.tcp_1.ocs_1, 14, 40, 40, 100, 0, 2, 1);
                ;
                new bola(this.tcp_1.ocs_1, 14, 40, 180, 100, 0, 2, 2);
                ;
                new bola(this.tcp_1.ocs_1, 14, 200, 40, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 14, 200, 180, 100, 0, 1, 2);
                ;
                break;
              case 5:
                this.tcp_1.ocs_1.uco_1 = 35;
                new bola(this.tcp_1.ocs_1, 12, 40, 100, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 12, 80, 80, 100, 0, 2, 1);
                ;
                new bola(this.tcp_1.ocs_1, 12, 120, 100, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 12, 160, 80, 100, 0, 2, 1);
                ;
                new bola(this.tcp_1.ocs_1, 12, 200, 100, 100, 0, 1, 1);
                ;
                break;
              case 6:
                this.tcp_1.ocs_1.uco_1 = 28;
                new bola(this.tcp_1.ocs_1, 14, 40, 180, 100, 0, 2, 2);
                ;
                new bola(this.tcp_1.ocs_1, 14, 200, 180, 100, 0, 1, 2);
                ;
                new bola(this.tcp_1.ocs_1, 10, 40, 60, 100, 0, 2, 1);
                ;
                new bola(this.tcp_1.ocs_1, 10, 200, 60, 100, 0, 1, 1);
                ;
                break;
              case 7:
                this.tcp_1.ocs_1.uco_1 = 22;
                new bola(this.tcp_1.ocs_1, 14, 40, 100, 25, 0, 1, 2);
                ;
                new bola(this.tcp_1.ocs_1, 10, 60, 100, 50, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 12, 100, 100, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 12, 140, 100, 100, 0, 2, 1);
                ;
                new bola(this.tcp_1.ocs_1, 10, 180, 100, 50, 0, 2, 1);
                ;
                new bola(this.tcp_1.ocs_1, 14, 200, 100, 25, 0, 2, 2);
                ;
                break;
              case 8:
                this.tcp_1.ocs_1.uco_1 = 42;
                new bola(this.tcp_1.ocs_1, 14, 20, 60, 100, 0, 1, 2);
                ;
                new bola(this.tcp_1.ocs_1, 12, 60, 80, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 10, 100, 100, 100, 0, 1, 1);
                ;
                new bola(this.tcp_1.ocs_1, 10, 140, 100, 100, 0, 2, 1);
                ;
                new bola(this.tcp_1.ocs_1, 12, 180, 80, 100, 0, 2, 1);
                ;
                new bola(this.tcp_1.ocs_1, 14, 220, 60, 100, 0, 2, 2);
                ;
                break;
              default:
                this.tcp_1.lci(GameScene$inicio$main$slambda_0(this.tcp_1.ocs_1, this.tcp_1, null));
                ;
                break;
            }

            if (this.ucp_1.dcj_1 < 9) {
              this.tcp_1.lci(GameScene$inicio$main$slambda_2(this.ucp_1, this.tcp_1, this.tcp_1.ocs_1, null));
            }

            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 6;
              continue $sm;
            }

            if (this.ucp_1.fcj_1 > get_record()) {
              set_record(this.ucp_1.fcj_1);
              this.tcp_1.ocs_1.qcs();
            }

            if (this.tcp_1.ocs_1.uco_1 === 0) {
              this.ucp_1.dcj_1 = this.ucp_1.dcj_1 + 1 | 0;
              println('FINISHED!');
              this.hh_1 = 2;
              suspendResult = delay(this.tcp_1.ocs_1, Companion_getInstance_7().ej(2.0), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 4;
              continue $sm;
            }

            break;
          case 2:
            var tmp_3 = this;
            tmp_3.vcp_1 = this.tcp_1.ocs_1.nag();
            var tmp_4 = this;
            tmp_4.wcp_1 = Companion_getInstance_7().ej(0.0);
            var tmp_5 = this;
            tmp_5.xcp_1 = this.vcp_1.j9t_1;
            this.hh_1 = 3;
            suspendResult = this.vcp_1.ras(getKClass(GameScene), [].slice(), this.wcp_1, this.xcp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            ;
            this.hh_1 = 4;
            continue $sm;
          case 4:
            this.hh_1 = 5;
            suspendResult = this.tcp_1.pci(this.tcp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.hh_1 = 1;
            continue $sm;
          case 6:
            return Unit_getInstance();
          case 7:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 7) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $mainCOROUTINE$7(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zcs_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$7).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 8;
            this.zcs_1.nci(this.zcs_1.xcv_1);
            this.act_1 = this.zcs_1.ccw_1;
            this.bct_1 = this.zcs_1.dcw_1;
            this.cct_1 = 0;
            this.dct_1 = this.zcs_1.acw_1 / 100.0;
            this.ect_1 = 0;
            this.fct_1 = null;
            position(this.zcs_1, this.zcs_1.ycv_1, this.zcs_1.zcv_1);
            ;
            anchor(this.zcs_1, 0.5, 1.0);
            ;
            scale(this.zcs_1, this.dct_1, this.dct_1);
            ;
            this.zcs_1.zbx(false);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 7;
              continue $sm;
            }

            this.hh_1 = 2;
            continue $sm;
          case 2:
            if (get_currentGameState().bcj_1) {
              this.hh_1 = 5;
              suspendResult = this.zcs_1.pci(this.zcs_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            if (this.zcs_1.oci() === 10) {
              if (this.act_1 === 0 ? this.bct_1 === 0 : false) {
                var tmp0_this = this.zcs_1;
                tmp0_this.sc6(tmp0_this.c6d() + 1);
                if (this.zcs_1.c6d() >= 30) {
                  var tmp_0 = this;
                  var tmp0_random = numberRangeToNumber(1, 2);
                  tmp_0.act_1 = random(tmp0_random, Default_getInstance());
                  this.bct_1 = 1;
                  this.cct_1 = 0;
                }
              }
              if (this.act_1 === 1) {
                var tmp1_this = this.zcs_1;
                tmp1_this.rc6(tmp1_this.b6d() - 3);
                if (this.zcs_1.b6d() < 10) {
                  this.zcs_1.rc6(10.0);
                  this.act_1 = 2;
                }
              }
              if (this.act_1 === 2) {
                var tmp2_this = this.zcs_1;
                tmp2_this.rc6(tmp2_this.b6d() + 3);
                if (this.zcs_1.b6d() > 230) {
                  this.zcs_1.rc6(230.0);
                  this.act_1 = 1;
                }
              }
              if (this.bct_1 === 1) {
                this.ect_1 = this.ect_1 + 1 | 0;
                var tmp3_this = this.zcs_1;
                tmp3_this.sc6(tmp3_this.c6d() + this.ect_1);
                if (this.ect_1 > 12) {
                  this.ect_1 = 12;
                }
                if (this.zcs_1.c6d() > 222) {
                  this.zcs_1.gcw_1.hcw().pcj();
                  this.zcs_1.sc6(222.0);
                  this.bct_1 = 2;
                }
              }
              if (this.bct_1 === 2) {
                var tmp4_this = this.zcs_1;
                tmp4_this.sc6(tmp4_this.c6d() - this.ect_1);
                this.ect_1 = this.ect_1 - 1 | 0;
                if (this.ect_1 < 0) {
                  this.ect_1 = 0;
                  this.bct_1 = 1;
                }
              }
            }

            if (this.zcs_1.oci() === 12) {
              if (this.act_1 === 0 ? this.bct_1 === 0 : false) {
                var tmp5_this = this.zcs_1;
                tmp5_this.sc6(tmp5_this.c6d() + 1);
                if (this.zcs_1.c6d() >= 30) {
                  var tmp_1 = this;
                  var tmp1_random = numberRangeToNumber(1, 2);
                  tmp_1.act_1 = random(tmp1_random, Default_getInstance());
                  this.bct_1 = 1;
                  this.cct_1 = 0;
                }
              }
              if (this.act_1 === 1) {
                var tmp6_this = this.zcs_1;
                tmp6_this.rc6(tmp6_this.b6d() - 1);
                if (this.zcs_1.b6d() < 10) {
                  this.zcs_1.rc6(10.0);
                  this.act_1 = 2;
                }
              }
              if (this.act_1 === 2) {
                var tmp7_this = this.zcs_1;
                tmp7_this.rc6(tmp7_this.b6d() + 1);
                if (this.zcs_1.b6d() > 230) {
                  this.zcs_1.rc6(230.0);
                  this.act_1 = 1;
                }
              }
              if (this.bct_1 === 1) {
                this.ect_1 = this.ect_1 + 1 | 0;
                var tmp8_this = this.zcs_1;
                tmp8_this.sc6(tmp8_this.c6d() + this.ect_1);
                if (this.ect_1 > 16) {
                  this.ect_1 = 16;
                }
                if (this.zcs_1.c6d() > 222) {
                  this.zcs_1.gcw_1.hcw().pcj();
                  this.zcs_1.sc6(222.0);
                  this.bct_1 = 2;
                }
              }
              if (this.bct_1 === 2) {
                var tmp9_this = this.zcs_1;
                tmp9_this.sc6(tmp9_this.c6d() - this.ect_1);
                this.ect_1 = this.ect_1 - 1 | 0;
                if (this.ect_1 < 0) {
                  this.ect_1 = 0;
                  this.bct_1 = 1;
                }
              }
            }

            if (this.zcs_1.oci() === 14) {
              if (this.act_1 === 0 ? this.bct_1 === 0 : false) {
                var tmp10_this = this.zcs_1;
                tmp10_this.sc6(tmp10_this.c6d() + 1);
                if (this.zcs_1.c6d() >= 30) {
                  var tmp_2 = this;
                  var tmp2_random = numberRangeToNumber(1, 2);
                  tmp_2.act_1 = random(tmp2_random, Default_getInstance());
                  this.bct_1 = 1;
                  this.cct_1 = 0;
                }
              }
              if (this.act_1 === 1) {
                var tmp11_this = this.zcs_1;
                tmp11_this.rc6(tmp11_this.b6d() - 2);
                if (this.zcs_1.b6d() < 10) {
                  this.zcs_1.rc6(10.0);
                  this.act_1 = 2;
                }
              }
              if (this.act_1 === 2) {
                var tmp12_this = this.zcs_1;
                tmp12_this.rc6(tmp12_this.b6d() + 2);
                if (this.zcs_1.b6d() > 230) {
                  this.zcs_1.rc6(230.0);
                  this.act_1 = 1;
                }
              }
              if (this.bct_1 === 1) {
                var tmp13_this = this.zcs_1;
                tmp13_this.sc6(tmp13_this.c6d() + 2);
                if (this.zcs_1.c6d() > 222) {
                  this.zcs_1.sc6(222.0);
                  this.bct_1 = 2;
                }
              }
              if (this.bct_1 === 2) {
                var tmp14_this = this.zcs_1;
                tmp14_this.sc6(tmp14_this.c6d() - 2);
                if (this.zcs_1.c6d() < 20) {
                  this.zcs_1.sc6(20.0);
                  this.bct_1 = 1;
                }
              }
            }

            if (this.zcs_1.oci() === 16) {
              if (this.act_1 === 0 ? this.bct_1 === 0 : false) {
                var tmp15_this = this.zcs_1;
                var tmp16 = tmp15_this.c6d();
                tmp15_this.sc6(tmp16 + 1);
                if (this.zcs_1.c6d() >= 30) {
                  var tmp_3 = this;
                  var tmp3_random = numberRangeToNumber(1, 2);
                  tmp_3.act_1 = random(tmp3_random, Default_getInstance());
                  this.bct_1 = 1;
                  this.cct_1 = 0;
                }
              }
              if (this.act_1 === 1) {
                var tmp17_this = this.zcs_1;
                tmp17_this.rc6(tmp17_this.b6d() - 4);
                if (this.zcs_1.b6d() < 10) {
                  this.zcs_1.rc6(10.0);
                  this.act_1 = 2;
                }
              }
              if (this.act_1 === 2) {
                var tmp18_this = this.zcs_1;
                tmp18_this.rc6(tmp18_this.b6d() + 4);
                if (this.zcs_1.b6d() > 230) {
                  this.zcs_1.rc6(230.0);
                  this.act_1 = 1;
                }
              }
              if (this.bct_1 === 1) {
                var tmp19_this = this.zcs_1;
                tmp19_this.sc6(tmp19_this.c6d() + 4);
                if (this.zcs_1.c6d() > 222) {
                  this.zcs_1.sc6(222.0);
                  this.bct_1 = 2;
                }
              }
              if (this.bct_1 === 2) {
                var tmp20_this = this.zcs_1;
                tmp20_this.sc6(tmp20_this.c6d() - 4);
                if (this.zcs_1.c6d() < 20) {
                  this.zcs_1.sc6(20.0);
                  this.bct_1 = 1;
                }
              }
            }

            if (!(this.act_1 === 0) ? !(this.bct_1 === 0) : false) {
              this.fct_1 = get_currentGameState().hcj_1.vcd(this.zcs_1, numberToInt(20 * this.dct_1));
              if ((!(this.fct_1 == null) ? ensureNotNull(this.fct_1).bcz_1 : false) ? this.zcs_1.ecw_1.ycd_1 : false) {
                ensureNotNull(this.fct_1).zcd();
                new explota(this.zcs_1.gcw_1, this.zcs_1.oci() + 1 | 0, numberToInt(this.zcs_1.b6d()), numberToInt(this.zcs_1.c6d()), this.dct_1 + 1.0, 25);
                var tmp21_this = get_currentGameState();
                var tmp22 = tmp21_this.gcj_1;
                tmp21_this.gcj_1 = tmp22 + 1 | 0;
                var tmp23_this = this.zcs_1.gcw_1;
                var tmp24 = tmp23_this.uco_1;
                tmp23_this.uco_1 = tmp24 - 1 | 0;
                if (this.dct_1 === 1.0) {
                  var tmp25_this = get_currentGameState();
                  tmp25_this.fcj_1 = tmp25_this.fcj_1 + 25 | 0;
                  new bola(this.zcs_1.gcw_1, this.zcs_1.oci(), numberToInt(this.zcs_1.b6d()) - 10 | 0, numberToInt(this.zcs_1.c6d()) - 10 | 0, 50, 0, 1, 2);
                  new bola(this.zcs_1.gcw_1, this.zcs_1.oci(), numberToInt(this.zcs_1.b6d()) + 10 | 0, numberToInt(this.zcs_1.c6d()) - 10 | 0, 50, 0, 2, 2);
                  this.zcs_1.ecw_1.zcd();
                }
                if (this.dct_1 === 0.5) {
                  var tmp26_this = get_currentGameState();
                  tmp26_this.fcj_1 = tmp26_this.fcj_1 + 50 | 0;
                  new bola(this.zcs_1.gcw_1, this.zcs_1.oci(), numberToInt(this.zcs_1.b6d()) - 10 | 0, numberToInt(this.zcs_1.c6d()) - 10 | 0, 25, 0, 1, 2);
                  new bola(this.zcs_1.gcw_1, this.zcs_1.oci(), numberToInt(this.zcs_1.b6d()) + 10 | 0, numberToInt(this.zcs_1.c6d()) - 10 | 0, 25, 0, 2, 2);
                  this.zcs_1.ecw_1.zcd();
                }
                if (this.dct_1 === 0.25) {
                  var tmp27_this = get_currentGameState();
                  tmp27_this.fcj_1 = tmp27_this.fcj_1 + 100 | 0;
                  this.zcs_1.ecw_1.zcd();
                }
                this.zcs_1.gcw_1.pcs();
              }
            }

            if (!this.zcs_1.ecw_1.ycd_1) {
              this.zcs_1.ecw_1.zcd();
            }

            this.hh_1 = 4;
            suspendResult = this.zcs_1.pci(this.zcs_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            if (false) {
              this.hh_1 = 2;
              continue $sm;
            }

            this.hh_1 = 6;
            continue $sm;
          case 5:
            this.gct_1 = Unit_getInstance();
            this.hh_1 = 6;
            continue $sm;
          case 6:
            this.hh_1 = 1;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 8) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $mainCOROUTINE$8(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lcz_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$8).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.lcz_1.hd2_1.hcw().rcj();
            this.lcz_1.nci(this.lcz_1.cd2_1);
            position(this.lcz_1, this.lcz_1.dd2_1, this.lcz_1.ed2_1);
            ;
            anchor_0(this.lcz_1, 0.5, 0.5);
            ;
            scale(this.lcz_1, this.lcz_1.fd2_1, this.lcz_1.fd2_1);
            ;
            this.lcz_1.zbx(false);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 3;
              continue $sm;
            }

            var tmp0_this = this.lcz_1;
            tmp0_this.kaz(tmp0_this.laz() - 0.2);
            ;
            var tmp1_this = this.lcz_1;
            tmp1_this.maz(tmp1_this.naz() - 0.2);
            ;
            if (this.lcz_1.laz() < 1) {
              this.lcz_1.cb0(0.5);
            }

            if (this.lcz_1.laz() < 0.01) {
              this.lcz_1.xb0();
            }

            this.hh_1 = 2;
            suspendResult = this.lcz_1.pci(this.lcz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function GameScene$prota$main$slambda($key, resultContinuation) {
    this.qd2_1 = $key;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(GameScene$prota$main$slambda).ea5 = function (it, $completion) {
    var tmp = this.fa5(it, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(GameScene$prota$main$slambda).mi = function (p1, $completion) {
    return this.ea5(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(GameScene$prota$main$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          this.qd2_1._v = setBits(this.qd2_1._v, getButtonPressed(this.rd2_1));
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(GameScene$prota$main$slambda).fa5 = function (it, completion) {
    var i = new GameScene$prota$main$slambda(this.qd2_1, completion);
    i.rd2_1 = it;
    return i;
  };
  function GameScene$prota$main$slambda_0($key, resultContinuation) {
    var i = new GameScene$prota$main$slambda($key, resultContinuation);
    var l = function (it, $completion) {
      return i.ea5(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function GameScene$prota$main$slambda_1($key, resultContinuation) {
    this.ad3_1 = $key;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(GameScene$prota$main$slambda_1).ea5 = function (it, $completion) {
    var tmp = this.fa5(it, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(GameScene$prota$main$slambda_1).mi = function (p1, $completion) {
    return this.ea5(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(GameScene$prota$main$slambda_1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          this.ad3_1._v = unsetBits(this.ad3_1._v, getButtonPressed(this.bd3_1));
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(GameScene$prota$main$slambda_1).fa5 = function (it, completion) {
    var i = new GameScene$prota$main$slambda_1(this.ad3_1, completion);
    i.bd3_1 = it;
    return i;
  };
  function GameScene$prota$main$slambda_2($key, resultContinuation) {
    var i = new GameScene$prota$main$slambda_1($key, resultContinuation);
    var l = function (it, $completion) {
      return i.ea5(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $mainCOROUTINE$9(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kd3_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$9).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 9;
            this.ld3_1 = 1;
            this.md3_1 = 0;
            this.nd3_1 = 0;
            this.kd3_1.nci(27);
            this.od3_1 = 212;
            this.pd3_1 = 1;
            this.qd3_1 = 1;
            this.rd3_1 = 20;
            this.sd3_1 = {_v: 0};
            var tmp0_run = get_keys(this.kd3_1);
            tmp0_run.ba7(GameScene$prota$main$slambda_0(this.sd3_1, null));
            ;
            tmp0_run.ca7(GameScene$prota$main$slambda_2(this.sd3_1, null));
            ;
            this.td3_1 = get_BUTTON_LEFT();
            this.ud3_1 = get_BUTTON_RIGHT();
            this.vd3_1 = get_BUTTON_A();
            position(this.kd3_1, this.kd3_1.qd6_1, this.od3_1);
            ;
            anchor_0(this.kd3_1, 0.5, 0.5);
            ;
            scale_0(this.kd3_1, this.pd3_1, this.pd3_1);
            ;
            this.kd3_1.zbx(false);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 8;
              continue $sm;
            }

            if (this.md3_1 < 3) {
              var tmp_0;
              var tmp0_toBool = this.sd3_1._v & this.td3_1;
              if (!(numberToInt(tmp0_toBool) === 0)) {
                tmp_0 = this.kd3_1.b6d() > 5;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                var tmp0_this = this.kd3_1;
                tmp0_this.rc6(tmp0_this.b6d() - 3);
                this.md3_1 = 2;
                if (this.ld3_1 === 1) {
                  this.kd3_1.nci(22);
                  this.ld3_1 = 0;
                }
              }
              var tmp_1;
              var tmp1_toBool = this.sd3_1._v & this.ud3_1;
              if (!(numberToInt(tmp1_toBool) === 0)) {
                tmp_1 = this.kd3_1.b6d() < 240;
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                var tmp1_this = this.kd3_1;
                tmp1_this.rc6(tmp1_this.b6d() + 3);
                this.md3_1 = 2;
                if (this.ld3_1 === 0) {
                  this.kd3_1.nci(26);
                  this.ld3_1 = 1;
                }
              }
            }

            var tmp2_toBool = this.sd3_1._v & this.vd3_1;
            if (!(numberToInt(tmp2_toBool) === 0)) {
              this.md3_1 = 5;
              this.kd3_1.nci(21);
            }

            this.md3_1 = this.md3_1 - 1 | 0;
            if (this.md3_1 === 0 ? this.ld3_1 === 0 : false) {
              this.kd3_1.nci(23);
            }

            if (this.md3_1 === 0 ? this.ld3_1 === 1 : false) {
              this.kd3_1.nci(27);
            }

            if (this.md3_1 > 0 ? this.md3_1 < 3 : false) {
              if (!(this.kd3_1.oci() === 21)) {
                var tmp2_this = this.kd3_1;
                var tmp3 = tmp2_this.oci();
                tmp2_this.nci(tmp3 + 1 | 0);
              }
              if (this.kd3_1.oci() === 21 ? this.ld3_1 === 0 : false) {
                this.kd3_1.nci(22);
              }
              if (this.kd3_1.oci() === 21 ? this.ld3_1 === 1 : false) {
                this.kd3_1.nci(26);
              }
              if (this.ld3_1 === 0 ? this.kd3_1.oci() > 25 : false) {
                this.kd3_1.nci(22);
              }
              if (this.ld3_1 === 1 ? this.kd3_1.oci() > 29 : false) {
                this.kd3_1.nci(26);
              }
            }

            if (this.md3_1 === 3) {
              new disparo(this.kd3_1.rd6_1, numberToInt(this.kd3_1.b6d()) + 6 | 0, numberToInt(this.kd3_1.c6d()) - 5 | 0);
            }

            this.nd3_1 = this.nd3_1 + 1 | 0;
            if (this.nd3_1 < 60) {
              this.kd3_1.cb0(0.5);
            }

            if (this.nd3_1 >= 60) {
              this.kd3_1.cb0(1.0);
              this.wd3_1 = get_currentGameState().icj_1.ucd(this.kd3_1, 15, -15);
              if (!(this.wd3_1 == null) ? this.wd3_1.fcw_1 : false) {
                println('' + this.kd3_1.b6d() + ',' + this.kd3_1.c6d() + ' - ' + new Vector2(this.wd3_1.e51()));
                var tmp4_this = get_currentGameState();
                var tmp5 = tmp4_this.ecj_1;
                tmp4_this.ecj_1 = tmp5 - 1 | 0;
                println('vidas ' + get_currentGameState().ecj_1);
                this.nd3_1 = 0;
                if (get_currentGameState().ecj_1 <= -1) {
                  println('GAME OVER');
                  get_currentGameState().bcj_1 = true;
                  this.hh_1 = 2;
                  suspendResult = delay(this.kd3_1.rd6_1, Companion_getInstance_7().ej(1.0), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.hh_1 = 4;
                  continue $sm;
                }
              } else {
                this.hh_1 = 5;
                continue $sm;
              }
            } else {
              this.hh_1 = 6;
              continue $sm;
            }

            break;
          case 2:
            var tmp_2 = this;
            tmp_2.xd3_1 = this.kd3_1.rd6_1.nag();
            var tmp_3 = this;
            tmp_3.yd3_1 = Companion_getInstance_7().ej(0.0);
            var tmp_4 = this;
            tmp_4.zd3_1 = this.xd3_1.j9t_1;
            this.hh_1 = 3;
            suspendResult = this.xd3_1.ras(getKClass(TitleScene), [].slice(), this.yd3_1, this.zd3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            ;
            this.hh_1 = 4;
            continue $sm;
          case 4:
            this.hh_1 = 5;
            continue $sm;
          case 5:
            this.hh_1 = 6;
            continue $sm;
          case 6:
            this.hh_1 = 7;
            suspendResult = this.kd3_1.pci(this.kd3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.hh_1 = 1;
            continue $sm;
          case 8:
            return Unit_getInstance();
          case 9:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 9) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $mainCOROUTINE$10(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ad7_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$10).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.ad7_1.nci(20);
            this.bd7_1 = 25;
            this.ad7_1.ccz_1.hcw().qcj();
            position(this.ad7_1, this.ad7_1.ycy_1, this.ad7_1.zcy_1);
            ;
            anchor_0(this.ad7_1, 0.5, 0.5);
            ;
            this.ad7_1.zbx(false);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 3;
              continue $sm;
            }

            var tmp0_this = this.ad7_1;
            tmp0_this.sc6(tmp0_this.c6d() - 6);
            ;
            if (this.ad7_1.c6d() < -20) {
              this.ad7_1.zcd();
            }

            this.ad7_1.kaz(this.ad7_1.laz() === 1.0 ? -1.0 : 1.0);
            this.hh_1 = 2;
            suspendResult = this.ad7_1.pci(this.ad7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $mainCOROUTINE$11(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kd7_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$11).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.kd7_1.nci(32);
            this.ld7_1 = 5;
            position_0(this.kd7_1, 0.0, 84.0);
            ;
            anchor_0(this.kd7_1, 0.5, 0.5);
            ;
            this.kd7_1.zbx(false);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 3;
              continue $sm;
            }

            this.md7_1 = get_currentGameState().ecj_1;
            if (this.md7_1 === 4) {
              this.kd7_1.rc6(340.0);
            }

            if (this.md7_1 === 3) {
              this.kd7_1.rc6(324.0);
            }

            if (this.md7_1 === 2) {
              this.kd7_1.rc6(309.0);
            }

            if (this.md7_1 === 1) {
              this.kd7_1.rc6(296.0);
            }

            if (this.md7_1 === 0) {
              this.kd7_1.rc6(284.0);
            }

            this.hh_1 = 2;
            suspendResult = this.kd7_1.pci(this.kd7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function inicio($outer) {
    this.ocs_1 = $outer;
    Process.call(this, $outer.xaj());
  }
  protoOf(inicio).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$6(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function bola($outer, initialGraph, initialX, initialY, size_x, flags, anima_x, anima_y) {
    this.gcw_1 = $outer;
    Process.call(this, $outer.xaj());
    this.xcv_1 = initialGraph;
    this.ycv_1 = initialX;
    this.zcv_1 = initialY;
    this.acw_1 = size_x;
    this.bcw_1 = flags;
    this.ccw_1 = anima_x;
    this.dcw_1 = anima_y;
    this.ecw_1 = new Collider(get_currentGameState().icj_1, this);
    this.fcw_1 = this.ecw_1.ycd_1;
  }
  protoOf(bola).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$7(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function explota($outer, initialGraph, initialX, initialY, size_x, z) {
    this.hd2_1 = $outer;
    Process.call(this, $outer.xaj());
    this.cd2_1 = initialGraph;
    this.dd2_1 = initialX;
    this.ed2_1 = initialY;
    this.fd2_1 = size_x;
    this.gd2_1 = z;
  }
  protoOf(explota).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$8(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function prota($outer, initialX) {
    this.rd6_1 = $outer;
    Process.call(this, $outer.xaj());
    this.qd6_1 = initialX;
  }
  protoOf(prota).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$9(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function disparo($outer, initialX, initialY) {
    this.ccz_1 = $outer;
    Process.call(this, $outer.xaj());
    this.ycy_1 = initialX;
    this.zcy_1 = initialY;
    this.acz_1 = new Collider(get_currentGameState().hcj_1, this);
    this.bcz_1 = this.acz_1.ycd_1;
  }
  protoOf(disparo).zcd = function () {
    this.acz_1.zcd();
  };
  protoOf(disparo).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$10(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function controlador($outer, parent) {
    this.dda_1 = $outer;
    Process.call(this, parent);
  }
  protoOf(controlador).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$11(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function GameScene$controlador_de_bolas$slambda($grafico_bola, $posicion_x, $tamano_bola, this$0, resultContinuation) {
    this.mda_1 = $grafico_bola;
    this.nda_1 = $posicion_x;
    this.oda_1 = $tamano_bola;
    this.pda_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(GameScene$controlador_de_bolas$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(GameScene$controlador_de_bolas$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(GameScene$controlador_de_bolas$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            var tmp0_random = numberRangeToNumber(0, 3);
            this.mda_1._v = random(tmp0_random, Default_getInstance());
            if (this.mda_1._v === 0) {
              this.mda_1._v = 10;
            }

            if (this.mda_1._v === 1) {
              this.mda_1._v = 12;
            }

            if (this.mda_1._v === 2) {
              this.mda_1._v = 14;
            }

            if (this.mda_1._v === 3) {
              this.mda_1._v = 16;
            }

            var tmp1_random = numberRangeToNumber(20, 220);
            this.nda_1._v = random(tmp1_random, Default_getInstance());
            var tmp2_random = numberRangeToNumber(0, 2);
            this.oda_1._v = random(tmp2_random, Default_getInstance());
            if (this.oda_1._v === 0) {
              this.oda_1._v = 100;
            }

            if (this.oda_1._v === 1) {
              this.oda_1._v = 50;
            }

            if (this.oda_1._v === 2) {
              this.oda_1._v = 25;
            }

            new bola(this.pda_1, this.mda_1._v, this.nda_1._v, -20, this.oda_1._v, 4, 0, 0);
            ;
            this.hh_1 = 1;
            suspendResult = delay(this.pda_1, Companion_getInstance_7().ej(3.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(GameScene$controlador_de_bolas$slambda).n1f = function (completion) {
    var i = new GameScene$controlador_de_bolas$slambda(this.mda_1, this.nda_1, this.oda_1, this.pda_1, completion);
    return i;
  };
  function GameScene$controlador_de_bolas$slambda_0($grafico_bola, $posicion_x, $tamano_bola, this$0, resultContinuation) {
    var i = new GameScene$controlador_de_bolas$slambda($grafico_bola, $posicion_x, $tamano_bola, this$0, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $sceneInitCOROUTINE$5(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yda_1 = _this__u8e3s4;
    this.zda_1 = _this__u8e3s4_0;
  }
  protoOf($sceneInitCOROUTINE$5).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = (new Resources(this.yda_1.ga6())).wcn(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.yda_1.xco_1 = new PafSounds(Companion_getInstance_11().ccm(), Companion_getInstance_11().dcm(), Companion_getInstance_11().ecm(), Companion_getInstance_11().fcm());
            get_currentGameState().jcj();
            new inicio(this.yda_1);
            ;
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $controlador_de_bolasCOROUTINE$12(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.idb_1 = _this__u8e3s4;
    this.jdb_1 = _this__u8e3s4_0;
  }
  protoOf($controlador_de_bolasCOROUTINE$12).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.kdb_1 = {_v: 0};
            this.ldb_1 = {_v: 0};
            this.mdb_1 = {_v: 0};
            this.hh_1 = 1;
            suspendResult = delay(this.idb_1, Companion_getInstance_7().ej(2.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            loop(this.idb_1, GameScene$controlador_de_bolas$slambda_0(this.kdb_1, this.ldb_1, this.mdb_1, this.idb_1, null));
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function GameScene() {
    SceneBase.call(this);
    this.uco_1 = 0;
  }
  protoOf(GameScene).ndb = function () {
    var tmp = this.vco_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('scoreText');
    }
  };
  protoOf(GameScene).odb = function () {
    var tmp = this.wco_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('recordText');
    }
  };
  protoOf(GameScene).hcw = function () {
    var tmp = this.xco_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('pafSounds');
    }
  };
  protoOf(GameScene).yaj = function (_this__u8e3s4, $completion) {
    var tmp = new $sceneInitCOROUTINE$5(this, _this__u8e3s4, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(GameScene).pcs = function () {
    this.ndb().kc6(padStart(get_currentGameState().fcj_1.toString(), 6, _Char___init__impl__6a9atx(48)));
  };
  protoOf(GameScene).qcs = function () {
    this.odb().kc6(padStart(get_record().toString(), 6, _Char___init__impl__6a9atx(48)));
  };
  protoOf(GameScene).yco = function (_this__u8e3s4, $completion) {
    var tmp = new $controlador_de_bolasCOROUTINE$12(this, _this__u8e3s4, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function LoadingScene$sceneAfterInit$slambda(this$0, resultContinuation) {
    this.xdb_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LoadingScene$sceneAfterInit$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(LoadingScene$sceneAfterInit$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(LoadingScene$sceneAfterInit$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.xdb_1.idc(this.xdb_1.xaj(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(LoadingScene$sceneAfterInit$slambda).n1f = function (completion) {
    var i = new LoadingScene$sceneAfterInit$slambda(this.xdb_1, completion);
    return i;
  };
  function LoadingScene$sceneAfterInit$slambda_0(this$0, resultContinuation) {
    var i = new LoadingScene$sceneAfterInit$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function LoadingScene$splash$slambda(this$0, $this_splash, $map, resultContinuation) {
    this.rdc_1 = this$0;
    this.sdc_1 = $this_splash;
    this.tdc_1 = $map;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LoadingScene$splash$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(LoadingScene$splash$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(LoadingScene$splash$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = this.rdc_1.udc(this.sdc_1, this.tdc_1._v, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(LoadingScene$splash$slambda).n1f = function (completion) {
    var i = new LoadingScene$splash$slambda(this.rdc_1, this.sdc_1, this.tdc_1, completion);
    return i;
  };
  function LoadingScene$splash$slambda_0(this$0, $this_splash, $map, resultContinuation) {
    var i = new LoadingScene$splash$slambda(this$0, $this_splash, $map, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function _interpolateFloat$ref() {
    var l = function (p0, p1, p2) {
      return _interpolateFloat(p0.k42_1, p1, p2);
    };
    l.callableName = '_interpolateFloat';
    return l;
  }
  function _interpolateFloat$ref_0() {
    var l = function (p0, p1, p2) {
      return _interpolateFloat(p0.k42_1, p1, p2);
    };
    l.callableName = '_interpolateFloat';
    return l;
  }
  function $sceneAfterInitCOROUTINE$13(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ddd_1 = _this__u8e3s4;
  }
  protoOf($sceneAfterInitCOROUTINE$13).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 8;
            this.hh_1 = 1;
            suspendResult = protoOf(Scene).aak.call(this.ddd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.edd_1 = async(this.ddd_1, LoadingScene$sceneAfterInit$slambda_0(this.ddd_1, null));
            this.hh_1 = 2;
            suspendResult = delay(this.ddd_1, Companion_getInstance_7().ej(1.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 3;
            suspendResult = (new Resources(this.ddd_1.ga6())).qcm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.hh_1 = 4;
            suspendResult = delay(this.ddd_1, Companion_getInstance_7().ej(3.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.hh_1 = 5;
            suspendResult = (new Resources(this.ddd_1.ga6())).rcm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            (new Resources(this.ddd_1.ga6())).xcn();
            this.hh_1 = 6;
            suspendResult = this.edd_1.d13(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_1 = this;
            tmp_1.fdd_1 = this.ddd_1.nag();
            var tmp_2 = this;
            tmp_2.gdd_1 = Companion_getInstance_7().ej(0.0);
            var tmp_3 = this;
            tmp_3.hdd_1 = this.fdd_1.j9t_1;
            this.hh_1 = 7;
            suspendResult = this.fdd_1.ras(getKClass(TitleScene), [].slice(), this.gdd_1, this.hdd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            ;
            return Unit_getInstance();
          case 8:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 8) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $splashCOROUTINE$14(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qdd_1 = _this__u8e3s4;
    this.rdd_1 = _this__u8e3s4_0;
  }
  protoOf($splashCOROUTINE$14).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 6;
            this.qdd_1.ga6().h9n_1 = Colors_getInstance().j48_1;
            this.hh_1 = 1;
            suspendResult = readBitmap(get_resourcesVfs().ro('korge.png'), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.sdd_1 = suspendResult;
            this.tdd_1 = slice(this.sdd_1);
            this.udd_1 = {_v: this.tdd_1};
            this.hh_1 = 2;
            suspendResult = this.qdd_1.udc(this.rdd_1, this.udd_1._v, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 3;
            suspendResult = readBitmap(get_resourcesVfs().ro('amakasoft.bmp'), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.vdd_1 = suspendResult;
            this.wdd_1 = slice(this.vdd_1);
            this.udd_1._v = this.wdd_1;
            var tmp_0 = this;
            tmp_0.xdd_1 = async(this.qdd_1, LoadingScene$splash$slambda_0(this.qdd_1, this.rdd_1, this.udd_1, null));
            this.hh_1 = 4;
            suspendResult = delay(this.qdd_1, Companion_getInstance_7().ej(1.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.qdd_1.ga6().h9n_1 = Colors_getInstance().k48_1;
            this.hh_1 = 5;
            suspendResult = this.xdd_1.d13(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            return Unit_getInstance();
          case 6:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 6) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $logoCOROUTINE$15(_this__u8e3s4, _this__u8e3s4_0, graph, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gde_1 = _this__u8e3s4;
    this.hde_1 = _this__u8e3s4_0;
    this.ide_1 = graph;
  }
  protoOf($logoCOROUTINE$15).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            var tmp_0 = this;
            var tmp2_image = Companion_getInstance_0().i3a_1;
            var tmp1_addTo = Image_init_$Create$(this.ide_1, tmp2_image);
            var tmp0_apply = addTo(tmp1_addTo, this.hde_1);
            tmp0_apply.cb0(0.0);
            ;
            tmp_0.jde_1 = tmp0_apply;
            this.hh_1 = 1;
            var tmp4_get = alpha$factory(this.jde_1);
            var tmp3_get = 1;
            var tmp_1 = tmp4_get.get();
            var tmp_2 = [new V2(tmp4_get, tmp_1, tmp3_get, _interpolateFloat$ref(), false)];
            suspendResult = tween(this.jde_1, tmp_2, Companion_getInstance_7().ej(1.0), Companion_getInstance_5().r3z(), VOID, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hh_1 = 2;
            suspendResult = delay(this.gde_1, Companion_getInstance_7().ej(1.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 3;
            var tmp6_get = alpha$factory_0(this.jde_1);
            var tmp5_get = 0;
            var tmp_3 = tmp6_get.get();
            var tmp_4 = [new V2(tmp6_get, tmp_3, tmp5_get, _interpolateFloat$ref_0(), false)];
            suspendResult = tween(this.jde_1, tmp_4, Companion_getInstance_7().ej(1.0), Companion_getInstance_5().r3z(), VOID, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function LoadingScene() {
    Scene.call(this);
  }
  protoOf(LoadingScene).yaj = function (_this__u8e3s4, $completion) {
    return Unit_getInstance();
  };
  protoOf(LoadingScene).aak = function ($completion) {
    var tmp = new $sceneAfterInitCOROUTINE$13(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(LoadingScene).idc = function (_this__u8e3s4, $completion) {
    var tmp = new $splashCOROUTINE$14(this, _this__u8e3s4, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(LoadingScene).udc = function (_this__u8e3s4, graph, $completion) {
    var tmp = new $logoCOROUTINE$15(this, _this__u8e3s4, graph, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function alpha$factory($b0) {
    return getPropertyCallableRef('alpha', 0, KMutableProperty0, function () {
      return $b0.db0();
    }, function (value) {
      return $b0.cb0(value);
    });
  }
  function alpha$factory_0($b0) {
    return getPropertyCallableRef('alpha', 0, KMutableProperty0, function () {
      return $b0.db0();
    }, function (value) {
      return $b0.cb0(value);
    });
  }
  function foto(_this__u8e3s4, graph, x, y, size_x, z, flags) {
    return new Foto(_this__u8e3s4, graph, x, y, size_x, z, flags);
  }
  function Foto(parent, initialGraph, xx, yy, size_x, z, flags) {
    Process.call(this, parent);
    this.adh_1 = initialGraph;
    this.bdh_1 = xx;
    this.cdh_1 = yy;
    this.ddh_1 = size_x;
    this.edh_1 = z;
    this.fdh_1 = flags;
  }
  protoOf(Foto).qch = function ($completion) {
    this.nci(this.adh_1);
    position(this, this.bdh_1, this.cdh_1);
    anchor_0(this, 0.5, 0.5);
    scale(this, this.ddh_1 / 100.0, this.ddh_1 / 100.0);
    this.zbx(false);
    return Unit_getInstance();
  };
  var musicPlaying;
  function TitleScene$inicio$main$slambda($tmp0_with, resultContinuation) {
    this.odh_1 = $tmp0_with;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TitleScene$inicio$main$slambda).y1i = function ($completion) {
    var tmp = this.n1f($completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(TitleScene$inicio$main$slambda).ai = function ($completion) {
    return this.y1i($completion);
  };
  protoOf(TitleScene$inicio$main$slambda).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 5;
              continue $sm;
            }

            this.odh_1.kaz(1.0);
            this.hh_1 = 2;
            suspendResult = delay_0(this.odh_1, Companion_getInstance_7().ej(0.25), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.odh_1.kaz(-1.0);
            this.hh_1 = 3;
            suspendResult = delay_0(this.odh_1, Companion_getInstance_7().ej(0.25), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.hh_1 = 1;
            continue $sm;
          case 4:
            throw this.kh_1;
          case 5:
            return Unit_getInstance();
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  protoOf(TitleScene$inicio$main$slambda).n1f = function (completion) {
    var i = new TitleScene$inicio$main$slambda(this.odh_1, completion);
    return i;
  };
  function TitleScene$inicio$main$slambda_0($tmp0_with, resultContinuation) {
    var i = new TitleScene$inicio$main$slambda($tmp0_with, resultContinuation);
    var l = function ($completion) {
      return i.y1i($completion);
    };
    l.$arity = 0;
    return l;
  }
  function TitleScene$inicio$main$slambda_1($key, resultContinuation) {
    this.xdh_1 = $key;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TitleScene$inicio$main$slambda_1).ea5 = function (it, $completion) {
    var tmp = this.fa5(it, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(TitleScene$inicio$main$slambda_1).mi = function (p1, $completion) {
    return this.ea5(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TitleScene$inicio$main$slambda_1).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          this.xdh_1._v = getButtonPressed(this.ydh_1);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TitleScene$inicio$main$slambda_1).fa5 = function (it, completion) {
    var i = new TitleScene$inicio$main$slambda_1(this.xdh_1, completion);
    i.ydh_1 = it;
    return i;
  };
  function TitleScene$inicio$main$slambda_2($key, resultContinuation) {
    var i = new TitleScene$inicio$main$slambda_1($key, resultContinuation);
    var l = function (it, $completion) {
      return i.ea5(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function TitleScene$inicio$main$slambda_3($key, resultContinuation) {
    this.hdi_1 = $key;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TitleScene$inicio$main$slambda_3).ea5 = function (it, $completion) {
    var tmp = this.fa5(it, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(TitleScene$inicio$main$slambda_3).mi = function (p1, $completion) {
    return this.ea5(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TitleScene$inicio$main$slambda_3).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        if (tmp === 0) {
          this.ih_1 = 1;
          this.hdi_1._v = unsetBits(this.hdi_1._v, getButtonPressed(this.idi_1));
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TitleScene$inicio$main$slambda_3).fa5 = function (it, completion) {
    var i = new TitleScene$inicio$main$slambda_3(this.hdi_1, completion);
    i.idi_1 = it;
    return i;
  };
  function TitleScene$inicio$main$slambda_4($key, resultContinuation) {
    var i = new TitleScene$inicio$main$slambda_3($key, resultContinuation);
    var l = function (it, $completion) {
      return i.ea5(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $mainCOROUTINE$19(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rdi_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$19).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 7;
            var tmp0_with = foto(this.rdi_1, 30, 160, 119, 100, 100, 0);
            tmp0_with.qci(TitleScene$inicio$main$slambda_0(tmp0_with, null));
            ;
            new letraTitulo(this.rdi_1.mdl_1, 10, 107, -60);
            ;
            new letraTitulo(this.rdi_1.mdl_1, 12, 146, -80);
            ;
            new letraTitulo(this.rdi_1.mdl_1, 14, 187, -100);
            ;
            new letraTitulo(this.rdi_1.mdl_1, 16, 220, -120);
            ;
            foto(this.rdi_1, 5, 160, 220, 100, 100, 0);
            ;
            new protaDemo(this.rdi_1.mdl_1);
            ;
            new pulsaIntro(this.rdi_1.mdl_1);
            ;
            this.hh_1 = 1;
            suspendResult = delay_0(this.rdi_1, Companion_getInstance_7().ej(1.0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.sdi_1 = {_v: 0};
            var tmp1_run = get_keys(this.rdi_1);
            tmp1_run.ba7(TitleScene$inicio$main$slambda_2(this.sdi_1, null));
            ;
            tmp1_run.ca7(TitleScene$inicio$main$slambda_4(this.sdi_1, null));
            ;
            this.hh_1 = 2;
            continue $sm;
          case 2:
            if (false) {
              this.hh_1 = 6;
              continue $sm;
            }

            var tmp0_toBool = this.sdi_1._v & (get_BUTTON_A() | get_BUTTON_B() | get_BUTTON_C() | get_BUTTON_START());
            if (!(numberToInt(tmp0_toBool) === 0)) {
              var tmp_0 = this;
              tmp_0.tdi_1 = this.rdi_1.mdl_1.nag();
              var tmp_1 = this;
              tmp_1.udi_1 = Companion_getInstance_7().ej(0.0);
              var tmp_2 = this;
              tmp_2.vdi_1 = this.tdi_1.j9t_1;
              this.hh_1 = 3;
              suspendResult = this.tdi_1.ras(getKClass(GameScene), [].slice(), this.udi_1, this.vdi_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.hh_1 = 4;
              continue $sm;
            }

            break;
          case 3:
            ;
            this.hh_1 = 4;
            continue $sm;
          case 4:
            this.hh_1 = 5;
            suspendResult = this.rdi_1.pci(this.rdi_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.hh_1 = 2;
            continue $sm;
          case 6:
            return Unit_getInstance();
          case 7:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 7) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $mainCOROUTINE$20(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vdl_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$20).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 5;
            position(this.vdl_1, 160, 200);
            ;
            anchor_0(this.vdl_1, 0.5, 0.5);
            ;
            this.vdl_1.zbx(false);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 4;
              continue $sm;
            }

            this.vdl_1.nci(6);
            this.hh_1 = 2;
            suspendResult = delay_0(this.vdl_1, Companion_getInstance_7().ej(0.125), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.vdl_1.nci(7);
            this.hh_1 = 3;
            suspendResult = delay_0(this.vdl_1, Companion_getInstance_7().ej(0.125), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.hh_1 = 1;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 5) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $mainCOROUTINE$21(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.edm_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$21).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.fdm_1 = 0;
            this.edm_1.nci(this.edm_1.wdo_1);
            position(this.edm_1, this.edm_1.xdo_1, this.edm_1.ydo_1);
            ;
            anchor_0(this.edm_1, 0.5, 0.5);
            ;
            scale(this.edm_1, 1.0, 1.0);
            ;
            this.edm_1.zbx(false);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 3;
              continue $sm;
            }

            if (this.fdm_1 === 0) {
              var tmp0_this = this.edm_1;
              tmp0_this.sc6(tmp0_this.c6d() + 6);
              if (this.edm_1.c6d() > 90) {
                this.edm_1.sc6(90.0);
                this.fdm_1 = 1;
                this.edm_1.zdo_1.hcw().rcj();
              }
            }

            if (this.fdm_1 === 1) {
              var tmp1_this = this.edm_1;
              var tmp2 = tmp1_this.oci();
              tmp1_this.nci(tmp2 + 1 | 0);
              this.edm_1.tc6(2.0);
              this.fdm_1 = 2;
            }

            if (this.fdm_1 === 2) {
              var tmp3_this = this.edm_1;
              tmp3_this.tc6(tmp3_this.uc6() - 0.2);
              if (this.edm_1.uc6() < 0.5) {
                this.edm_1.tc6(1.0);
                this.fdm_1 = 3;
              }
            }

            if (this.fdm_1 === 3) {
              if (this.edm_1.oci() === 11) {
                this.edm_1.nci(1);
              }
              if (this.edm_1.oci() === 13) {
                this.edm_1.nci(2);
              }
              if (this.edm_1.oci() === 15) {
                this.edm_1.nci(3);
              }
              if (this.edm_1.oci() === 17) {
                this.edm_1.nci(4);
              }
              this.fdm_1 = 4;
            }

            this.hh_1 = 2;
            suspendResult = this.edm_1.pci(this.edm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $mainCOROUTINE$22(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tdp_1 = _this__u8e3s4;
  }
  protoOf($mainCOROUTINE$22).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 4;
            this.udp_1 = 0;
            this.tdp_1.nci(22);
            position(this.tdp_1, 340, 160);
            ;
            anchor_0(this.tdp_1, 0.5, 0.5);
            ;
            scale(this.tdp_1, 1.0, 1.0);
            ;
            this.tdp_1.zbx(false);
            this.hh_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this.hh_1 = 3;
              continue $sm;
            }

            if (this.udp_1 === 0) {
              var tmp0_this = this.tdp_1;
              var tmp1 = tmp0_this.oci();
              tmp0_this.nci(tmp1 + 1 | 0);
              if (this.tdp_1.oci() > 25) {
                this.tdp_1.nci(22);
              }
              this.tdp_1.rc6(this.tdp_1.b6d() - 3);
              if (this.tdp_1.b6d() < -20) {
                this.tdp_1.rc6(-20.0);
                this.udp_1 = 1;
                this.tdp_1.nci(26);
              }
            }

            if (this.udp_1 === 1) {
              var tmp2_this = this.tdp_1;
              var tmp3 = tmp2_this.oci();
              tmp2_this.nci(tmp3 + 1 | 0);
              if (this.tdp_1.oci() > 29) {
                this.tdp_1.nci(26);
              }
              this.tdp_1.rc6(this.tdp_1.b6d() + 3);
              if (this.tdp_1.b6d() > 340) {
                this.tdp_1.rc6(340.0);
                this.udp_1 = 0;
                this.tdp_1.nci(22);
              }
            }

            this.hh_1 = 2;
            suspendResult = this.tdp_1.pci(this.tdp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.hh_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 4) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function inicio_0($outer) {
    this.mdl_1 = $outer;
    Process.call(this, $outer.xaj());
  }
  protoOf(inicio_0).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$19(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function pulsaIntro($outer) {
    this.lds_1 = $outer;
    Process.call(this, $outer.xaj());
  }
  protoOf(pulsaIntro).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$20(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function letraTitulo($outer, initialGraph, initialX, initialY) {
    this.zdo_1 = $outer;
    Process.call(this, $outer.xaj());
    this.wdo_1 = initialGraph;
    this.xdo_1 = initialX;
    this.ydo_1 = initialY;
  }
  protoOf(letraTitulo).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$21(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function protaDemo($outer) {
    this.cdv_1 = $outer;
    Process.call(this, $outer.xaj());
  }
  protoOf(protaDemo).qch = function ($completion) {
    var tmp = new $mainCOROUTINE$22(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  function $sceneInitCOROUTINE$16(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ldv_1 = _this__u8e3s4;
    this.mdv_1 = _this__u8e3s4_0;
  }
  protoOf($sceneInitCOROUTINE$16).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = (new Resources(this.ldv_1.ga6())).wcn(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ldv_1.kdp_1 = new PafSounds(Companion_getInstance_11().ccm(), Companion_getInstance_11().dcm(), Companion_getInstance_11().ecm(), Companion_getInstance_11().fcm());
            if (musicPlaying === 0) {
              musicPlaying = 1;
              this.ldv_1.hcw().scj();
            }

            set_currentGameState(new GameState());
            new inicio_0(this.ldv_1);
            ;
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $sceneDestroyCOROUTINE$17(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vdv_1 = _this__u8e3s4;
  }
  protoOf($sceneDestroyCOROUTINE$17).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = protoOf(SceneBase).cak.call(this.vdv_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            println('Destroy');
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function $sceneAfterDestroyCOROUTINE$18(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.edw_1 = _this__u8e3s4;
  }
  protoOf($sceneAfterDestroyCOROUTINE$18).ph = function () {
    var suspendResult = this.jh_1;
    $sm: do
      try {
        var tmp = this.hh_1;
        switch (tmp) {
          case 0:
            this.ih_1 = 2;
            this.hh_1 = 1;
            suspendResult = protoOf(SceneBase).waj.call(this.edw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            println('AfterDestroy');
            return Unit_getInstance();
          case 2:
            throw this.kh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ih_1 === 2) {
          throw e;
        } else {
          this.hh_1 = this.ih_1;
          this.kh_1 = e;
        }
      }
     while (true);
  };
  function TitleScene() {
    SceneBase.call(this);
  }
  protoOf(TitleScene).hcw = function () {
    var tmp = this.kdp_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('pafSounds');
    }
  };
  protoOf(TitleScene).yaj = function (_this__u8e3s4, $completion) {
    var tmp = new $sceneInitCOROUTINE$16(this, _this__u8e3s4, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(TitleScene).cak = function ($completion) {
    var tmp = new $sceneDestroyCOROUTINE$17(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  protoOf(TitleScene).waj = function ($completion) {
    var tmp = new $sceneAfterDestroyCOROUTINE$18(this, $completion);
    tmp.jh_1 = Unit_getInstance();
    tmp.kh_1 = null;
    return tmp.ph();
  };
  //region block: post-declaration
  protoOf(Process).o6a = dispatch$default;
  protoOf(Process).q6a = dispatch;
  protoOf(Process).p6a = onEvents;
  protoOf(inicio).o6a = dispatch$default;
  protoOf(inicio).q6a = dispatch;
  protoOf(inicio).p6a = onEvents;
  protoOf(bola).o6a = dispatch$default;
  protoOf(bola).q6a = dispatch;
  protoOf(bola).p6a = onEvents;
  protoOf(explota).o6a = dispatch$default;
  protoOf(explota).q6a = dispatch;
  protoOf(explota).p6a = onEvents;
  protoOf(prota).o6a = dispatch$default;
  protoOf(prota).q6a = dispatch;
  protoOf(prota).p6a = onEvents;
  protoOf(disparo).o6a = dispatch$default;
  protoOf(disparo).q6a = dispatch;
  protoOf(disparo).p6a = onEvents;
  protoOf(controlador).o6a = dispatch$default;
  protoOf(controlador).q6a = dispatch;
  protoOf(controlador).p6a = onEvents;
  protoOf(Foto).o6a = dispatch$default;
  protoOf(Foto).q6a = dispatch;
  protoOf(Foto).p6a = onEvents;
  protoOf(inicio_0).o6a = dispatch$default;
  protoOf(inicio_0).q6a = dispatch;
  protoOf(inicio_0).p6a = onEvents;
  protoOf(pulsaIntro).o6a = dispatch$default;
  protoOf(pulsaIntro).q6a = dispatch;
  protoOf(pulsaIntro).p6a = onEvents;
  protoOf(letraTitulo).o6a = dispatch$default;
  protoOf(letraTitulo).q6a = dispatch;
  protoOf(letraTitulo).p6a = onEvents;
  protoOf(protaDemo).o6a = dispatch$default;
  protoOf(protaDemo).q6a = dispatch;
  protoOf(protaDemo).p6a = onEvents;
  //endregion
  //region block: init
  BUTTON_UP = 1;
  BUTTON_DOWN = 2;
  BUTTON_LEFT = 4;
  BUTTON_RIGHT = 8;
  BUTTON_A = 16;
  BUTTON_B = 32;
  BUTTON_C = 64;
  BUTTON_START = 128;
  musicPlaying = 0;
  //endregion
  main(get_EmptyContinuation());
  return _;
}));
